export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "Transparente, grenzenlose Infrastruktur für Großzügigkeit.",
    "common.skipToMainContent": "Zum Hauptinhalt springen",
    "common.cancel": "Abbrechen",
    "common.edit": "Bearbeiten",
    "common.delete": "Löschen",
    "common.creating": "Wird erstellt...",
    "common.unknown": "Unbekannt",
    "common.notAvailable": "k. A.",

    // Navigation
    "nav.browse": "Organisationen durchsuchen",
    "nav.opportunities": "Freiwilligenmöglichkeiten",
    "nav.contributions": "Beitragsübersicht",
    "nav.governance": "Governance",
    "nav.dashboard": "Give Dashboard",
    "nav.about": "Über uns",
    "nav.docs": "Dokumentation",
    "nav.legal": "Rechtliches",
    "nav.launchApp": "App starten",

    // FAQ page (GIV-988)
    "faq.title": "Häufig gestellte Fragen",
    "faq.subtitle":
      "Alles, was Sie über Spenden, Freiwilligenarbeit und Blockchain-Transparenz wissen müssen.",

    // Settings
    "settings.title": "Einstellungen",
    "settings.language": "Sprache",
    "settings.currency": "Währung",

    // Auth
    "auth.login": "Anmelden",
    "auth.register": "Konto erstellen",
    "auth.logout": "Abmelden",
    "auth.forgotPassword": "Passwort vergessen?",

    // Dashboard
    "dashboard.title": "Give Dashboard",
    "dashboard.subtitle": "Verfolgen Sie Ihre Spenden und Freiwilligenbeiträge",
    "dashboard.totalDonations": "Gesamtspenden",
    "dashboard.volunteerHours": "Freiwilligenstunden",
    "dashboard.skillsEndorsed": "Bestätigte Fähigkeiten",
    "dashboard.contributions": "Beiträge",
    "dashboard.yourTotalDonated": "Ihre Gesamtspenden",
    "dashboard.yourVolunteerHours": "Ihre Freiwilligenstunden",
    "dashboard.yourSkillsEndorsed": "Ihre bestätigten Fähigkeiten",
    "dashboard.impactGrowth": "Wirkungswachstum",
    "dashboard.charitiesSupported": "Unterstützte Organisationen",

    // Charity
    "charity.dashboard": "Wohltätigkeits-Dashboard",
    "charity.subtitle": "Verwalten Sie Ihre Spenden und Freiwilligenprogramme",
    "charity.activeVolunteers": "Aktive Freiwillige",
    "charity.transactions": "Transaktionen",
    "charity.volunteers": "Freiwilligenstunden",
    "charity.applications": "Bewerbungen",
    "charity.totalReceived": "Insgesamt erhalten",
    "charity.equityPoolValue": "Wert des Eigenkapitalpools",
    "charity.availableBalance": "Verfügbares Guthaben",

    // Contributions
    "contributions.date": "Datum",
    "contributions.type": "Typ",
    "contributions.organization": "Organisation",
    "contributions.details": "Details",
    "contributions.status": "Status",
    "contributions.verification": "Verifizierung",
    "contributions.export": "CSV exportieren",

    // Volunteer
    "volunteer.opportunities": "Freiwilligenmöglichkeiten",
    "volunteer.searchOpportunities": "Möglichkeiten suchen...",
    "volunteer.selectSkill": "Fähigkeit auswählen",
    "volunteer.selectType": "Typ auswählen",
    "volunteer.selectLanguage": "Sprache auswählen",
    "volunteer.allSkills": "Alle Fähigkeiten",
    "volunteer.allTypes": "Alle Typen",
    "volunteer.allLanguages": "Alle Sprachen",
    "volunteer.applyNow": "Jetzt bewerben",
    "volunteer.noOpportunitiesFound":
      "Keine Möglichkeiten gefunden, die Ihren Kriterien entsprechen.",
    "volunteer.verify": "Stunden verifizieren",
    "volunteer.verifying": "Wird verifiziert...",
    "volunteer.reject": "Ablehnen",
    "volunteer.accept": "Annehmen",
    "volunteer.processing": "Wird verarbeitet...",
    "volunteer.hours": "Stunden am",
    "volunteer.description": "Beschreibung",
    "volunteer.appliedFor": "Beworben für",
    "volunteer.verificationComplete": "Verifizierung abgeschlossen",
    "volunteer.hoursVerified":
      "Die Freiwilligenstunden wurden verifiziert und auf der Blockchain erfasst.",
    "volunteer.verificationHash": "Verifizierungs-Hash",
    "volunteer.applicationAccepted": "Bewerbung angenommen",
    "volunteer.applicationRecorded":
      "Die Freiwilligenbewerbung wurde angenommen und auf der Blockchain erfasst.",
    "volunteer.acceptanceHash": "Annahme-Hash",
    "volunteer.pendingHours": "Ausstehende Freiwilligenstunden",
    "volunteer.noPendingHours":
      "Keine ausstehenden Freiwilligenstunden zur Verifizierung.",
    "volunteer.pendingApplications": "Ausstehende Bewerbungen",
    "volunteer.noPendingApplications":
      "Keine ausstehenden Bewerbungen zur Prüfung.",
    "volunteer.createOpportunity": "Freiwilligenmöglichkeit erstellen",
    "volunteer.createNew": "Neu erstellen",
    "volunteer.noOpportunitiesYet":
      "Noch keine Möglichkeiten erstellt. Klicken Sie auf \u201ENeu erstellen\u201C, um zu beginnen.",
    "volunteer.opportunityTitle": "Titel der Möglichkeit",
    "volunteer.skills": "Fähigkeiten (kommagetrennt)",
    "volunteer.commitment": "Engagement",
    "volunteer.location": "Standort",
    "volunteer.type": "Typ",
    "volunteer.workLanguage": "Arbeitssprache",
    "volunteer.status": "Status",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "Einmalig",
    "volunteer.commitment.shortTerm": "Kurzfristig",
    "volunteer.commitment.longTerm": "Langfristig",

    // Volunteer types
    "volunteer.type.remote": "Remote",
    "volunteer.type.onsite": "Vor Ort",
    "volunteer.type.hybrid": "Hybrid",
    "volunteer.type.onSite": "Vor Ort",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "Arbeitstyp-Filter",
    "volunteer.searchLocation": "Stadt oder Region...",
    "volunteer.searchLocationAria": "Standort suchen",
    "volunteer.filter.skill": "Fähigkeit: {{value}}",
    "volunteer.filter.type": "Typ: {{value}}",
    "volunteer.filter.language": "Sprache: {{value}}",
    "volunteer.filter.location": "Standort: {{value}}",
    "volunteer.loadingOpportunities": "Möglichkeiten werden geladen...",
    "volunteer.loadOpportunitiesError": "Freiwilligenmöglichkeiten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
    "volunteer.viewDetails": "Details ansehen",
    "volunteer.backToOpportunities": "Zurück zu den Möglichkeiten",
    "volunteer.detail.about": "Über diese Möglichkeit",
    "volunteer.detail.skills": "Erforderliche Fähigkeiten",
    "volunteer.detail.commitment": "Zeitaufwand",
    "volunteer.detail.location": "Standort",
    "volunteer.detail.language": "Sprache",
    "volunteer.detail.hostedBy": "Veranstaltet von",
    "volunteer.detail.ongoing": "Fortlaufend",
    "volunteer.detail.applicationsClosed": "Bewerbungen geschlossen",
    "volunteer.detail.notFoundTitle": "Möglichkeit nicht gefunden",
    "volunteer.detail.notFoundMessage": "Diese Möglichkeit wurde möglicherweise besetzt oder entfernt.",
    "volunteer.field.requirements": "Anforderungen",
    "volunteer.field.benefits": "Vorteile",
    "volunteer.field.schedule": "Zeitplan",
    "volunteer.field.schedulePlaceholder": "z. B. dienstags 18-20 Uhr, flexible Wochenenden",
    "volunteer.field.startDate": "Startdatum",
    "volunteer.field.endDate": "Enddatum",
    "volunteer.field.endDateHelp": "Leer lassen, wenn fortlaufend",
    "volunteer.field.applicationDeadline": "Bewerbungsfrist",
    "volunteer.field.volunteersNeeded": "Benötigte Freiwillige",
    "volunteer.field.minimumAge": "Mindestalter",
    "volunteer.field.backgroundCheckRequired": "Führungszeugnis erforderlich",
    "volunteer.field.trainingProvided": "Schulung wird angeboten",
    "volunteer.field.onePerLine": "eine pro Zeile",
    "volunteer.validation.volunteersNeeded": "Geben Sie eine Zahl ab 1 ein",
    "volunteer.validation.minimumAge": "Geben Sie ein Alter zwischen 0 und 120 ein",
    "volunteer.validation.endDate": "Das Enddatum muss am oder nach dem Startdatum liegen",
    "volunteer.signInToApply":
      "Bitte melden Sie sich an, um sich für Freiwilligenmöglichkeiten zu bewerben",
    "volunteer.applicationSuccess": "Bewerbung erfolgreich eingereicht!",
    "volunteer.removeFilter": "Filter {{filter}} entfernen",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "Titel ist erforderlich",
    "volunteer.validation.descriptionRequired": "Beschreibung ist erforderlich",
    "volunteer.validation.skillsRequired":
      "Mindestens eine Fähigkeit ist erforderlich",
    "volunteer.validation.locationRequired": "Standort ist erforderlich",
    "volunteer.profileNotFound": "Benutzerprofil nicht gefunden",
    "volunteer.correctErrors": "Bitte korrigieren Sie die Validierungsfehler",
    "volunteer.createFailed": "Möglichkeit konnte nicht erstellt werden",
    "volunteer.descriptionPlaceholder":
      "Beschreiben Sie die Freiwilligenmöglichkeit im Detail...",
    "volunteer.skillsPlaceholder":
      "z. B. Webentwicklung, Projektmanagement, Übersetzung",
    "volunteer.locationPlaceholder": "z. B. Remote, New York, Berlin",
    "volunteer.headerImage": "Headerbild",
    "volunteer.headerImageHelp":
      "Laden Sie ein Bild hoch, das oben in Ihrer Möglichkeitsanzeige angezeigt wird",
    "volunteer.limitReached": "Möglichkeitenlimit erreicht",
    "volunteer.limitReachedMessage":
      "Sie haben das Maximum von {{max}} aktiven Freiwilligenmöglichkeiten erreicht. Bitte schließen oder beenden Sie eine bestehende Möglichkeit, bevor Sie eine neue erstellen.",
    "volunteer.opportunityCount":
      "Sie haben {{count}} von {{max}} aktiven Möglichkeiten.",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "Stundenverifizierung",
    "volunteer.hoursVerificationDescription":
      "Überprüfen und verifizieren Sie eingereichte Freiwilligenstunden",
    "volunteer.formalHours": "Erfasste Stunden",
    "volunteer.selfReported": "Selbst gemeldet",
    "volunteer.loggedHours": "Erfasste Freiwilligenstunden",
    "volunteer.loggedHoursDescription":
      "Von Freiwilligen über Ihre Möglichkeiten erfasste Stunden",
    "volunteer.allCaughtUp": "Alles erledigt!",
    "volunteer.noPendingLoggedHours":
      "Keine ausstehenden erfassten Stunden zur Verifizierung.",
    "volunteer.selfReportedHours": "Selbst gemeldete Stunden",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "Noch keine Möglichkeiten",
    "volunteer.activeCount": "{{count}} von {{max}} aktiven Möglichkeiten",
    "volunteer.moreSkills": "+{{count}} weitere",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "Keine ausstehenden Bewerbungen",
    "volunteer.unknownOpportunity": "Unbekannte Möglichkeit",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "Freiwilligenbeitrag verifizieren",
    "volunteer.hashPlaceholder": "Verifizierungs-Hash eingeben",
    "volunteer.searching": "Wird gesucht...",
    "volunteer.verifyHash": "Hash verifizieren",
    "volunteer.verificationNotFound": "Verifizierung nicht gefunden",
    "volunteer.verificationNotFoundMessage":
      "Der eingegebene Hash konnte in unseren Aufzeichnungen nicht gefunden werden. Bitte überprüfen Sie den Hash und versuchen Sie es erneut.",
    "volunteer.unknownOrganization": "Unbekannte Organisation",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification":
      "Verifizierung des Freiwilligenbeitrags",
    "volunteer.volunteerLabel": "Freiwillige/r",
    "volunteer.opportunityLabel": "Möglichkeit",
    "volunteer.organizationLabel": "Organisation",
    "volunteer.acceptedOn": "Angenommen am",
    "volunteer.verifiedOn": "Verifiziert am",
    "volunteer.verificationHashes": "Verifizierungs-Hashes",
    "volunteer.blockchainReference": "Blockchain-Referenz",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "Beitrag wird verifiziert\u2026",
    "volunteer.noHashProvided": "Kein Verifizierungs-Hash angegeben.",
    "volunteer.verificationSuccessful": "Verifizierung erfolgreich",
    "volunteer.contributionVerifiedBlockchain":
      "Dieser Freiwilligenbeitrag wurde verifiziert und auf der Blockchain erfasst.",
    "volunteer.verificationFailed": "Verifizierung fehlgeschlagen",
    "volunteer.hashNotFound":
      "Der Verifizierungs-Hash {{hash}} konnte nicht gefunden werden oder ist ungültig.",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "Freiwilligenstunden",
    "volunteer.aboutSelfReported": "Über selbst gemeldete Stunden",
    "volunteer.selfReportedInfo":
      "Nur Stunden, die von verifizierten Organisationen bestätigt wurden, zählen für die globalen Wirkungsrankings. Stunden für Organisationen, die nicht auf unserer Plattform sind, können erfasst werden, werden aber als \u201eUnbestätigt\u201c markiert, bis eine Bestätigung vorliegt.",
    "volunteer.logHoursButton": "Stunden erfassen",
    "volunteer.logVolunteerHours": "Freiwilligenstunden erfassen",
    "volunteer.editRecord": "Eintrag bearbeiten",
    "volunteer.recordDetails": "Eintragsdetails",
    "volunteer.backToList": "Zurück zur Liste",
    "volunteer.deleteRecord": "Eintrag löschen?",
    "volunteer.deleteConfirmation":
      "Möchten Sie diesen Freiwilligenstunden-Eintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "Aktivitätstyp",
    "volunteer.organization": "Organisation",
    "volunteer.searchRegistry": "Register durchsuchen",
    "volunteer.searchRegistryPlaceholder":
      "Im Register nach Name oder Steuer-ID suchen…",
    "volunteer.registryTaxId": "Steuer-ID {{value}}",
    "volunteer.notListed": "Nicht aufgeführt",
    "volunteer.organizationName": "Organisationsname",
    "volunteer.enterOrgName": "Organisationsname eingeben",
    "volunteer.contactEmail": "Kontakt-E-Mail",
    "volunteer.contactEmailOptional": "(optional)",
    "volunteer.onboardHelp":
      "Wir kontaktieren die Organisation möglicherweise, um sie einzubinden",
    "volunteer.submittedForValidation":
      "Dieser Eintrag wird zur Bestätigung eingereicht",
    "volunteer.submittedForValidationTo":
      "Dieser Eintrag wird zur Bestätigung an {{org}} eingereicht",
    "volunteer.validationExpired":
      "Der Bestätigungszeitraum für dieses Datum ist abgelaufen",
    "volunteer.savedAsUnvalidated":
      "Dieser Eintrag wird als unbestätigt gespeichert",
    "volunteer.describeActivities":
      "Beschreiben Sie die durchgeführten Aktivitäten...",
    "volunteer.moreCharsNeeded": "Noch {{count}} Zeichen erforderlich",
    "volunteer.updating": "Wird aktualisiert...",
    "volunteer.logging": "Wird erfasst...",
    "volunteer.updateHours": "Stunden aktualisieren",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "Status",
    "volunteer.activityTypeFilter": "Aktivitätstyp",
    "volunteer.filterFrom": "Von",
    "volunteer.filterTo": "Bis",
    "volunteer.clearFilters": "Filter zurücksetzen",
    "volunteer.allStatuses": "Alle",
    "volunteer.allActivityTypes": "Alle Typen",
    "volunteer.noMatchingRecords": "Keine passenden Einträge",
    "volunteer.noHoursLogged": "Noch keine Freiwilligenstunden erfasst",
    "volunteer.adjustFilters":
      "Versuchen Sie, Ihre Filter anzupassen, um Einträge zu finden.",
    "volunteer.startLogging":
      "Beginnen Sie mit der Erfassung Ihrer ersten Freiwilligenstunden.",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "Bestätigte Stunden",
    "volunteer.pendingValidation": "Bestätigung ausstehend",
    "volunteer.unvalidatedHours": "Unbestätigte Stunden",
    "volunteer.rejectedLabel": "Abgelehnt",
    "volunteer.hoursUnit": "Std.",
    "volunteer.recordSingular": "Eintrag",
    "volunteer.recordPlural": "Einträge",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "Bewerbung als Freiwillige/r",
    "volunteer.applicationSubtitle":
      "Helfen Sie mit, durch verifizierte Beiträge nachhaltige Wirkung zu erzielen",
    "volunteer.progress.info": "Info",
    "volunteer.progress.skills": "Fähigkeiten",
    "volunteer.progress.consent": "Zustimmung",
    "volunteer.fieldValid": "Sieht gut aus",
    "volunteer.draftSaved": "Entwurf gespeichert",
    "volunteer.personalInfo": "Persönliche Informationen",
    "volunteer.firstName": "Vorname",
    "volunteer.lastName": "Nachname",
    "volunteer.emailAddress": "E-Mail-Adresse",
    "volunteer.phoneNumber": "Telefonnummer",
    "volunteer.locationCity": "Standort/Stadt",
    "volunteer.locationCityPlaceholder": "z. B. Berlin, Deutschland",
    "volunteer.timeZone": "Zeitzone",
    "volunteer.selectTimeZone": "Zeitzone auswählen",
    "volunteer.ageRange": "Altersgruppe",
    "volunteer.selectAgeRange": "Altersgruppe auswählen",
    "volunteer.skillsAndInterests": "Fähigkeiten & Interessen",
    "volunteer.skillsLabel": "Fähigkeiten und Interessengebiete",
    "volunteer.skillPlaceholderFull":
      "Geben Sie Ihre Fähigkeiten ein (z. B. Python-Programmierung, Rhetorik, Antragsstellung)",
    "volunteer.skillPlaceholderShort":
      "Fähigkeit eingeben und Enter drücken...",
    "volunteer.commitmentLevel": "Engagementgrad",
    "volunteer.commitmentOneTimeDesc":
      "Einzelprojekt oder kurzfristige Aufgaben",
    "volunteer.commitmentShortTermDesc": "Einige Wochen bis wenige Monate",
    "volunteer.commitmentLongTermDesc":
      "Fortlaufendes Engagement über mehrere Monate oder länger",
    "volunteer.experienceLabel":
      "Erzählen Sie uns von Ihrer relevanten Erfahrung",
    "volunteer.experiencePlaceholder":
      "Beschreiben Sie Ihren Hintergrund, Ihre Fähigkeiten und was Sie motiviert, bei Give Protocol mitzuwirken...",
    "volunteer.consentTitle": "Einwilligung & Vereinbarung",
    "volunteer.consentHeader": "Einwilligung zur Freiwilligenbewerbung",
    "volunteer.submitting": "Wird eingereicht...",
    "volunteer.submitApplication": "Freiwilligenbewerbung einreichen",
    "volunteer.disclaimerText":
      "Mit dem Einreichen dieser Bewerbung bestätigen Sie, dass Sie die Datenschutzrichtlinien und Freiwilligenrichtlinien von Give Protocol gelesen und verstanden haben. Ihre Daten werden gemäß den geltenden Datenschutzbestimmungen verarbeitet.",
    "volunteer.validation.firstNameInvalid":
      "Bitte geben Sie einen gültigen Vornamen ein",
    "volunteer.validation.lastNameInvalid":
      "Bitte geben Sie einen gültigen Nachnamen ein",
    "volunteer.validation.emailInvalid":
      "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "volunteer.validation.phoneInvalid":
      "Bitte geben Sie eine gültige Telefonnummer ein",
    "volunteer.validation.experienceRequired":
      "Bitte beschreiben Sie Ihre relevante Erfahrung",
    "volunteer.validation.addSkill":
      "Bitte fügen Sie mindestens eine Fähigkeit hinzu",
    "volunteer.validation.ageRangeRequired":
      "Bitte wählen Sie Ihre Altersgruppe aus",
    "volunteer.validation.consentRequired":
      "Sie müssen allen erforderlichen Einwilligungen zustimmen",
    "volunteer.signInToSubmit":
      "Bitte melden Sie sich an, um eine Bewerbung einzureichen",
    "volunteer.submitFailed":
      "Bewerbung konnte nicht eingereicht werden. Bitte versuchen Sie es erneut.",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "Bewerben für: {{title}}",
    "volunteer.fullName": "Vollständiger Name *",
    "volunteer.phoneRequired": "Telefonnummer *",
    "volunteer.emailRequired": "E-Mail-Adresse *",
    "volunteer.dateOfBirth": "Geburtsdatum",
    "volunteer.availabilityTitle": "Verfügbarkeit",
    "volunteer.preferredDays": "Bevorzugte Tage",
    "volunteer.preferredTimes": "Bevorzugte Zeiten",
    "volunteer.commitmentLevelLabel": "Engagementgrad",
    "volunteer.skillsAndExperience": "Fähigkeiten & Erfahrung",
    "volunteer.relevantExperience": "Relevante Erfahrung *",
    "volunteer.certifications": "Zertifizierungen (kommagetrennt)",
    "volunteer.interestsAndPreferences": "Interessen & Präferenzen",
    "volunteer.areasOfInterest": "Interessengebiete (kommagetrennt)",
    "volunteer.referencesTitle": "Referenzen",
    "volunteer.referenceName": "Referenz {{index}} Name",
    "volunteer.referenceContact": "Referenz {{index}} Kontakt",
    "volunteer.workSamplesTitle": "Arbeitsproben",
    "volunteer.workSamplesLabel": "Links zu Arbeitsproben (kommagetrennt)",
    "volunteer.submitApplicationShort": "Bewerbung einreichen",
    "volunteer.validation.nameInvalid":
      "Bitte geben Sie einen gültigen Namen ein (2–100 Zeichen)",
    "volunteer.validation.provideExperience":
      "Bitte geben Sie Informationen zu Ihrer Erfahrung an",
    "volunteer.validation.selectDay":
      "Bitte wählen Sie mindestens einen Tag aus",
    "volunteer.validation.selectTime":
      "Bitte wählen Sie mindestens eine Uhrzeit aus",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "Ich verstehe, dass:",
    "volunteer.processingAckTitle": "VERARBEITUNGSBESTÄTIGUNG",
    "volunteer.processingAckDesc":
      "Bitte prüfen Sie das Folgende und bestätigen Sie es, bevor Sie fortfahren:",
    "volunteer.essentialProcessingTitle":
      "Antragsverarbeitung (Bestätigung erforderlich):",
    "volunteer.acknowledgmentTitle": "BESTÄTIGUNG",
    "volunteer.ageConfirmationTitle": "Altersbestätigung:",
    "volunteer.privacyNoticeTitle": "Datenschutzhinweis:",
    "volunteer.doNotAccept": "Nicht akzeptieren",
    "volunteer.acceptAndContinue": "Akzeptieren und fortfahren",
    "volunteer.validation.essentialRequired":
      "Sie müssen die Verarbeitungsbestätigung des Antrags bestätigen, um fortzufahren",
    "volunteer.validation.agePrivacyRequired":
      "Sie müssen Ihr Alter bestätigen und bestätigen, dass Sie den Datenschutzhinweis gelesen haben",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "Ich bestätige, dass ich 16 Jahre oder älter bin.",
    "ageGate.negative":
      "Give Protocol steht Nutzern ab 16 Jahren zur Verfügung. Wenn Sie unter 16 Jahre alt sind, können wir Ihre Anfrage derzeit nicht bearbeiten.",

    // Languages
    "language.english": "Englisch",
    "language.spanish": "Spanisch",
    "language.german": "Deutsch",
    "language.french": "Französisch",
    "language.japanese": "Japanisch",
    "language.chinese_simplified": "Chinesisch (Vereinfacht)",
    "language.chinese_traditional": "Chinesisch (Traditionell)",
    "language.thai": "Thailändisch",
    "language.vietnamese": "Vietnamesisch",
    "language.korean": "Koreanisch",
    "language.arabic": "Arabisch",
    "language.hindi": "Hindi",
    "language.multiple": "Mehrere Sprachen",

    // Contribution types
    "contribution.type.donation": "Spende",
    "contribution.type.volunteerapplication": "Freiwilligenbewerbung",
    "contribution.type.volunteerhours": "Freiwilligenstunden",
    "contribution.type.volunteeracceptance": "Freiwilligenannahme",
    "contribution.type.volunteerverification": "Freiwilligenverifizierung",

    // Donor/Volunteer
    "donor.volunteer": "Spender/Freiwillige/r",
    "donor.anonymous": "Anonym",
    "volunteer.unknown": "Unbekannte/r Freiwillige/r",

    // Statuses
    "status.completed": "Abgeschlossen",
    "status.pending": "Ausstehend",
    "status.failed": "Fehlgeschlagen",

    // Blockchain
    "blockchain.block": "Block",

    // Filter
    "filter.allYears": "Alle Jahre",
    "filter.allTypes": "Alle Typen",
    "filter.donations": "Spenden",
    "filter.volunteerApplications": "Freiwilligenbewerbungen",
    "filter.volunteerHours": "Freiwilligenstunden",
    "filter.fiatDonations": "Fiat-Spenden",

    // Export
    "export.title": "Beitragsdaten exportieren",
    "export.filename": "Dateiname",
    "export.dateRange": "Datumsbereich",
    "export.includePersonal": "Wallet-Adressen einschließen",
    "export.willInclude": "Der Export wird Folgendes enthalten:",
    "export.walletAddresses": "Wallet-Adressen (Sender und Empfänger)",
    "export.volunteerDetails":
      "Details zu Freiwilligenbeiträgen (falls zutreffend)",
    "export.verificationHashes": "Verifizierungs-Hashes (falls zutreffend)",
    "export.cancel": "Abbrechen",
    "export.download": "CSV exportieren",

    // Skills
    "skills.endorsements": "Fähigkeiten & Empfehlungen",

    // Home
    "home.subtitle":
      "Ressourcen mit den Anliegen verbinden, die sie am meisten brauchen",
    "home.startDonating": "Jetzt spenden",

    // Modal - shared
    "modal.close": "Modal schließen",
    "modal.closeAriaLabel": "Schließen",

    // Modal - wallet connection
    "modal.wallet.title": "Wallet verbinden",
    "modal.wallet.description":
      "Verbinden Sie ein Wallet, um alle Funktionen von Give Protocol freizuschalten",
    "modal.wallet.benefit1":
      "Verfolgen Sie Ihre Spenden transparent auf der Blockchain",
    "modal.wallet.benefit2":
      "Erhalten Sie GIVE-Token als Belohnung für Ihre Beiträge",
    "modal.wallet.benefit3":
      "Beteiligen Sie sich an Governance-Entscheidungen für das Protokoll",
    "modal.wallet.connecting": "Wird verbunden...",
    "modal.wallet.clickToConnect": "Zum Verbinden klicken",
    "modal.wallet.noExtension": "Keine Wallet-Erweiterung erkannt.",
    "modal.wallet.installMetaMask": "Installieren Sie MetaMask, um zu beginnen",
    "modal.wallet.skip": "Vorerst überspringen",
    "modal.wallet.footerNote":
      "Sie können Ihr Wallet jederzeit über die Navigationsleiste verbinden",
    "modal.wallet.failedConnect": "Wallet konnte nicht verbunden werden",

    // Modal - wallet link
    "modal.walletLink.title": "Wallet verknüpfen",
    "modal.walletLink.description":
      "Verknüpfen Sie ein Wallet mit Ihrem Konto für On-Chain-Spenden, Token-Belohnungen und Governance",
    "modal.walletLink.benefit1":
      "Spenden Sie Kryptowährung direkt an verifizierte Organisationen on-chain",
    "modal.walletLink.benefit2Pre": "Entwickeln Sie",
    "modal.walletLink.benefit2Post": "Nachweise für Ihre Beiträge",
    "modal.walletLink.benefit3":
      "Melden Sie sich mit E-Mail oder Wallet an \u2014 dasselbe Konto",
    "modal.walletLink.buttonLinking": "Wird verknüpft\u2026",
    "modal.walletLink.buttonLink": "Wallet verknüpfen",
    "modal.walletLink.buttonConnectFirst": "Zuerst Wallet verbinden",
    "modal.walletLink.footerNote":
      "Sie können Ihr Wallet jederzeit in den Einstellungen verknüpfen",
    "modal.walletLink.failedLink": "Wallet konnte nicht verknüpft werden",

    // Modal - chain selection
    "modal.chain.title": "Willkommen bei Give Protocol",
    "modal.chain.subtitle":
      "Wählen Sie Ihr bevorzugtes Netzwerk, um zu beginnen",
    "modal.chain.footerNote":
      "Sie können das Netzwerk jederzeit über das Menü wechseln",
    "modal.chain.connecting": "Wird verbunden...",
    "modal.chain.continue": "Weiter",
    "modal.chain.failedSelect": "Netzwerk konnte nicht ausgewählt werden",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "Netzwerk auswählen",
    "modal.network.nextStep": "Nächster Schritt: Wallet verbinden",
    "modal.network.learnMore": "Mehr über die Netzwerkauswahl erfahren",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "Wallet verbinden",
    "modal.connect.backAria": "Zurück zur Netzwerkauswahl",
    "modal.connect.noWallets":
      "Keine Wallets für {{chainType}}-Chains verfügbar.",
    "modal.connect.tryDifferentChain":
      "Versuchen Sie, einen anderen Chain-Typ auszuwählen.",
    "modal.connect.viewOtherWallets": "Andere unterstützte Wallets anzeigen",
    "modal.connect.termsAgreement": "Durch die Verbindung stimmen Sie unseren",
    "modal.connect.termsLink": "Nutzungsbedingungen",
    "modal.connect.termsPrivacyConnector": "und",
    "modal.connect.privacyLink": "Datenschutzrichtlinie",
    "modal.connect.chainTypeAria": "Chain-Typ",
    "modal.connect.failedConnect": "Verbindung fehlgeschlagen",

    // Modal - donation
    "modal.donation.successTitle": "Vielen Dank!",
    "modal.donation.donationProcessedOneTime":
      "Ihre Spende von {{amount}} an {{charityName}} wurde verarbeitet.",
    "modal.donation.donationProcessedRecurring":
      "Ihre monatliche Spende von {{amount}} an {{charityName}} wurde verarbeitet.",
    "modal.donation.recurringNote":
      "Sie werden monatlich belastet, bis Sie kündigen.",
    "modal.donation.receiptNote":
      "Eine Quittung wurde an Ihre E-Mail-Adresse gesendet.",
    "modal.donation.done": "Fertig",
    "modal.donation.errorTitle": "Etwas ist schiefgelaufen",
    "modal.donation.errorDefault":
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "modal.donation.tryAgain": "Erneut versuchen",
    "modal.donation.close": "Schließen",
    "modal.donation.amountLabel": "Spendenbetrag",
    "modal.donation.perMonth": "pro Monat",
    "modal.donation.monthly": "Monatlich",
    "modal.donation.oneTime": "Einmalig",
    "modal.donation.loadingPaymentForm": "Zahlungsformular wird geladen...",
    "modal.donation.supportMonthly": "{{charityName}} monatlich unterstützen",
    "modal.donation.donateToCharity": "An {{charityName}} spenden",

    // Modal - scheduled donation
    "modal.scheduledDonation.title":
      "Monatliche Spenden an {{charityName}} planen",

    // Modal - withdrawal
    "modal.withdrawal.title": "Auszahlung beantragen",

    // Modal - validation response
    "modal.validation.rejectTitle": "Bestätigungsanfrage ablehnen",
    "modal.validation.reviewTitle": "Bestätigungsanfrage prüfen",
    "modal.validation.volunteer": "Freiwillige/r",
    "modal.validation.activityDetails": "Aktivitätsdetails",
    "modal.validation.date": "Datum",
    "modal.validation.hour": "Stunde",
    "modal.validation.hours": "Stunden",
    "modal.validation.activityType": "Aktivitätstyp",
    "modal.validation.location": "Standort",
    "modal.validation.description": "Beschreibung",
    "modal.validation.submitted": "Eingereicht:",
    "modal.validation.daysRemaining":
      "({{count}} Tage verbleibend zur Bestätigung)",
    "modal.validation.appealNote":
      "Dies ist ein Einspruch/eine erneute Einreichung einer zuvor abgelehnten Anfrage",
    "modal.validation.rejectPrompt":
      "Bitte wählen Sie einen Grund für die Ablehnung dieser Bestätigungsanfrage. Der/die Freiwillige wird benachrichtigt.",
    "modal.validation.reject": "Ablehnen",
    "modal.validation.approve": "Genehmigen",
    "modal.validation.processing": "Wird verarbeitet...",
    "modal.validation.back": "Zurück",
    "modal.validation.confirmRejection": "Ablehnung bestätigen",
    "modal.validation.selectReasonError":
      "Bitte wählen Sie einen Ablehnungsgrund aus",

    // Toast
    "toast.dismiss": "Benachrichtigung schließen",

    // Error boundary
    "error.somethingWrong": "Etwas ist schiefgelaufen",
    "error.unexpectedError": "Ein unerwarteter Fehler ist aufgetreten",
    "error.tryAgain": "Erneut versuchen",
    "error.tooManyAttempts": "Zu viele Versuche",
    "error.goHome": "Zur Startseite",
    "error.details": "Fehlerdetails",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "Ablehnungsgrund",
    "validation.rejection.reasonPlaceholder": "Grund auswählen...",
    "validation.rejection.notesLabel": "Zusätzliche Anmerkungen",
    "validation.rejection.optional": "(optional)",
    "validation.rejection.notesPlaceholder":
      "Geben Sie zusätzlichen Kontext für die Ablehnung an...",

    // Validation - batch actions
    "validation.batch.deselectAll": "Alle abwählen",
    "validation.batch.selectAll": "Alle auswählen",
    "validation.batch.selected": "{{selected}} von {{total}} ausgewählt",
    "validation.batch.clear": "Zurücksetzen",
    "validation.batch.reject": "Ablehnen ({{count}})",
    "validation.batch.approve": "Genehmigen ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "Admin-Dashboard",
    "dashboard.adminNote":
      "Bitte verwenden Sie das Admin-Panel, um die Plattform zu verwalten.",
    "dashboard.adminButton": "Zum Admin-Panel",
    "dashboard.logVolunteerHours": "Freiwilligenstunden erfassen",
    "dashboard.hideVolunteerHours": "Freiwilligenstunden ausblenden",
    "dashboard.viewMonthlyDonations": "Monatliche Spenden anzeigen",
    "dashboard.hideMonthlyDonations": "Monatliche Spenden ausblenden",
    "dashboard.walletSettings": "Wallet-Einstellungen",
    "dashboard.overview": "Übersicht",
    "dashboard.lastUpdated": "Zuletzt aktualisiert",
    "dashboard.refreshData": "Daten aktualisieren",
    "dashboard.searchPlaceholder": "Projekte, Freiwillige suchen (Cmd+K)",
    "dashboard.search": "Suchen",

    // Settings - account section (GIV-254)
    "settings.manageDescription":
      "Verwalten Sie Ihr Konto und Ihre Einstellungen",
    "settings.account": "Konto",
    "settings.email": "E-Mail",
    "settings.displayName": "Anzeigename",
    "settings.authMethod": "Authentifizierungsmethode",
    "settings.role": "Rolle",

    // Common additional (GIV-254)
    "common.refresh": "Aktualisieren",
    "common.all": "Alle",
    "common.loading": "Wird geladen...",
    "common.close": "Schließen",
    "common.back": "Zurück",

    // Cause (GIV-254)
    "cause.createCause": "Anliegen erstellen",

    // Contribution Tracker (GIV-254)
    "tracker.title": "Globale Wirkungsrankings",
    "tracker.subtitle":
      "Verfolgen und feiern Sie die gemeinsame Wirkung unserer Gemeinschaft",
    "tracker.searchPlaceholder": "Beitragende suchen...",
    "tracker.exportCSV": "CSV exportieren",
    "tracker.exportPDF": "PDF exportieren",
    "tracker.hideContributions": "Meine Beiträge aus Rankings ausblenden",
    "tracker.yourAlias": "Ihr Alias:",
    "tracker.changeAlias": "Ändern",
    "tracker.setWalletAlias": "Wallet-Alias festlegen",
    "tracker.aliasTitle": "Wallet-Alias festlegen",
    "tracker.aliasDescription":
      "Ihr Alias wird in der Beitragsübersicht anstelle Ihrer Wallet-Adresse angezeigt.",
    "tracker.aliasLabel": "Alias",
    "tracker.aliasPlaceholder": "Geben Sie Ihren bevorzugten Alias ein",
    "tracker.saveAlias": "Alias speichern",
    "tracker.donationRankings": "Spendenrankings",
    "tracker.volunteerRankings": "Freiwilligenrankings",
    "tracker.exportComplete": "Export abgeschlossen",
    "tracker.exportDonationCSV": "Spendenrangliste als CSV exportiert",
    "tracker.exportVolunteerCSV": "Freiwilligenrangliste als CSV exportiert",
    "tracker.exportPDFSuccess": "Rangliste als PDF exportiert",
    "tracker.exportFailed": "Export fehlgeschlagen",
    "tracker.exportNoData": "Keine Daten zum Exportieren verfügbar",
    "tracker.exportError":
      "Beim Exportieren der Daten ist ein Fehler aufgetreten",
    "tracker.walletNotConnected": "Wallet nicht verbunden",
    "tracker.connectWalletForAlias":
      "Bitte verbinden Sie Ihr Wallet, um einen Alias festzulegen",
    "tracker.invalidAlias": "Ungültiger Alias",
    "tracker.enterValidAlias": "Bitte geben Sie einen gültigen Alias ein",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "{{type}} löschen?",
    "charity.portal.deleteDescription":
      "Diese Aktion kann nicht rückgängig gemacht werden. {{type}} wird dauerhaft entfernt.",
    "charity.portal.walletNotConfigured": "Empfangs-Wallet nicht konfiguriert.",
    "charity.portal.walletDonationNote":
      "Verbinden Sie ein Wallet, um On-Chain-Spenden zu erhalten.",
    "charity.portal.setupWallet": "Wallet einrichten",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "Einrichtungs-Checkliste",
    "charity.onboarding.title": "Erste Schritte",
    "charity.onboarding.progress":
      "{{completed}} von {{total}} Schritten abgeschlossen",
    "charity.onboarding.optional": "Optional",
    "charity.onboarding.allComplete":
      "Alle Schritte abgeschlossen! Sie können diese Checkliste schließen.",
    "charity.onboarding.expand": "Checkliste erweitern",
    "charity.onboarding.collapse": "Checkliste einklappen",
    "charity.onboarding.dismiss": "Einrichtungs-Checkliste schließen",
    "charity.onboarding.check": "{{label}} abhaken",
    "charity.onboarding.uncheck": "Haken bei {{label}} entfernen",
    "charity.onboarding.stepDone": "{{label}} (abgeschlossen)",
    "charity.onboarding.stepAuto": "{{label}} (wird automatisch abgeschlossen)",
    "charity.onboarding.goToOrganization": "Zur Organisation",
    "charity.onboarding.setupWallet": "Wallet einrichten",
    "charity.onboarding.item.completeProfile.label":
      "Organisationsprofil vervollständigen",
    "charity.onboarding.item.completeProfile.description":
      "Fügen Sie Name, Beschreibung, Adresse und Kontaktdaten Ihrer Organisation hinzu.",
    "charity.onboarding.item.uploadLogo.label":
      "Logo oder Bannerbild hochladen",
    "charity.onboarding.item.uploadLogo.description":
      "Fügen Sie ein Logo oder Banner hinzu, damit Spender Ihre Wohltätigkeitsorganisation wiedererkennen.",
    "charity.onboarding.item.connectWallet.label": "Empfangs-Wallet einrichten",
    "charity.onboarding.item.connectWallet.description":
      "Wählen Sie ein Multisig-Safe, eine institutionelle Verwahrung oder eine Wallet mit einem einzelnen Unterzeichner, um Spenden zu empfangen. Weisen Sie die Kontrolle nach, indem Sie eine Nachricht signieren.",
    "charity.onboarding.item.bankDetails.label":
      "Bankdaten für die Fiat-Auszahlung einrichten",
    "charity.onboarding.item.bankDetails.description":
      "Hinterlegen Sie Bankdaten, wenn Sie Kartenspenden annehmen möchten.",
    "charity.onboarding.item.acceptTerms.label":
      "Nutzungsbedingungen prüfen und akzeptieren",
    "charity.onboarding.item.acceptTerms.description":
      "Lesen und bestätigen Sie die Bedingungen von Give Protocol für Wohltätigkeitsorganisationen.",
    "charity.verification.pendingTitle": "Antrag in Prüfung",
    "charity.verification.pendingBody":
      "Ihr Antrag als Wohltätigkeitsorganisation wird von unserem Team geprüft. Das dauert in der Regel 3–5 Werktage. Wir informieren Sie per E-Mail, sobald eine Entscheidung vorliegt.",
    "charity.verification.rejectedTitle": "Antrag nicht genehmigt",
    "charity.verification.reason": "Grund: {{notes}}",
    "charity.verification.rejectedDefault":
      "Ihr Antrag wurde derzeit nicht genehmigt.",
    "charity.verification.contactSupport": "Support kontaktieren",
    "charity.verification.suspendedTitle": "Konto gesperrt",
    "charity.verification.suspendedDefault":
      "Das Konto Ihrer Wohltätigkeitsorganisation wurde gesperrt.",
    "charity.verification.appealSuspension": "Sperrung anfechten",
    "charity.verification.verifiedTitle": "Organisation verifiziert",
    "charity.verification.verifiedBody":
      "Ihre Organisation ist verifiziert und Spender können jetzt Ihre Projekte unterstützen.",
    "charity.portal.receivingWallet": "Empfangs-Wallet: {{address}}",
    "charity.portal.loadError":
      "Daten der Wohltätigkeitsorganisation konnten nicht geladen werden. Bitte versuchen Sie es erneut.",

    // Timestamps (GIV-254)
    "timestamp.justNow": "Gerade eben",
    "timestamp.oneMinuteAgo": "Vor 1 Minute",
    "timestamp.minutesAgo": "Vor {{count}} Minuten",

    // Common additions (GIV-256)
    "common.previous": "Zurück",
    "common.next": "Weiter",
    "common.pageOfTotal": "Seite {{page}} von {{total}}",
    "common.retry": "Wiederholen",
    "common.processing": "Wird verarbeitet...",
    "common.saving": "Wird gespeichert...",
    "common.donate": "Spenden",
    "common.active": "Aktiv",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "Spendentyp",
    "portfolio.devNative": "DEV (Nativ)",
    "portfolio.testToken": "TEST Token",
    "portfolio.donationAmount": "Spendenbetrag:",
    "portfolio.platformFee": "Plattformgebühr ({{percentage}}%):",
    "portfolio.toCharities": "An Organisationen:",
    "portfolio.eachCharityReceives": "Jede Organisation erhält:",
    "portfolio.donateToFund": "An {{name}} spenden",
    "portfolio.equalDistribution": "Gleichmäßige Verteilung",
    "portfolio.equalDistributionNote":
      "Ihre Spende wird gleichmäßig auf {{count}} verifizierte Organisationen aufgeteilt.",
    "portfolio.eachCharityPercentage":
      "Jede Organisation erhält {{percentage}}% der Spenden",
    "portfolio.verifiedCharities": "{{count}} verifizierte Organisationen",
    "portfolio.donateToFundButton": "An Fonds spenden",
    "portfolio.noFundsAvailable": "Keine Portfolio-Fonds verfügbar",
    "portfolio.checkBackLater":
      "Schauen Sie später nach neuen Fördermöglichkeiten",
    "portfolio.amountLabel": "Betrag ({{currency}})",
    "portfolio.invalidAmount": "Bitte geben Sie einen gültigen Betrag ein",
    "portfolio.donationSuccess": "Spende erfolgreich!",
    "portfolio.donationFailed":
      "Spende fehlgeschlagen. Bitte versuchen Sie es erneut.",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "Spende",
    "admin.activity.registration": "Registrierung",
    "admin.activity.verification": "Verifizierung",
    "admin.activity.volunteerHours": "Freiwilligenstunden",
    "admin.activity.default": "Aktivität",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "Admin-Dashboard",
    "admin.dashboard.alerts": "Benachrichtigungen",
    "admin.dashboard.alertsPending": "{{count}} ausstehend",
    "admin.dashboard.alertsView": "Ansehen",
    "admin.dashboard.recentActivity": "Letzte Aktivitäten",
    "admin.dashboard.noRecentActivity": "Keine letzten Aktivitäten.",
    "admin.dashboard.quickActions": "Schnellaktionen",
    "admin.dashboard.errorTitle": "Fehler beim Laden des Dashboards",
    "admin.stats.last7d": "letzte 7 Tage",
    "admin.stats.last30d": "letzte 30 Tage",
    "admin.stats.totalDonors": "Spender gesamt",
    "admin.stats.newRegistrations": "neue Registrierungen",
    "admin.stats.charities": "Organisationen",
    "admin.stats.pendingVerification": "ausstehende Verifizierung",
    "admin.stats.verifiedCharities": "Verifizierte Organisationen",
    "admin.stats.activeVolunteers": "Aktive Freiwillige",
    "admin.stats.totalDonationVolume": "Gesamtspendenvolumen",
    "admin.stats.cryptoVolume": "Krypto-Volumen",
    "admin.stats.fiatVolume": "Fiat-Volumen",
    "admin.stats.donations": "Spenden",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "Berichte anzeigen",
    "admin.actions.viewReportsDesc": "Detaillierte Analysen erstellen",
    "admin.actions.manageCharities": "Organisationen verwalten",
    "admin.actions.manageCharitiesDesc": "Organisationen prüfen und genehmigen",
    "admin.actions.systemSettings": "Systemeinstellungen",
    "admin.actions.systemSettingsDesc": "Plattformparameter konfigurieren",
    "admin.actions.manageImpactMetrics": "Wirkungskennzahlen verwalten",
    "admin.actions.manageImpactMetricsDesc":
      "Daten des Wirkungsrechners konfigurieren",
    "admin.actions.donationMonitoring": "Spendenüberwachung",
    "admin.actions.donationMonitoringDesc":
      "Spenden überwachen, markieren und darüber berichten",
    "admin.actions.contentModeration": "Inhaltsmoderation",
    "admin.actions.contentModerationDesc":
      "Möglichkeiten und Anliegen ausblenden, markieren und prüfen",
    "admin.actions.portfolioFunds": "Portfolio-Fonds",
    "admin.actions.portfolioFundsDesc":
      "Kuratierte Spendenportfolios erstellen und verwalten",
    "admin.actions.charityRequests": "Organisationsanfragen",
    "admin.actions.charityRequestsDesc":
      "Spenderanfragen für nicht beanspruchte Organisationen prüfen",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "Portfolio-Fonds",
    "admin.portfolio.subtitle":
      "Kuratierte Spendenportfolios erstellen und verwalten",
    "admin.portfolio.newFund": "Neuer Fonds",
    "admin.portfolio.editFund": "Fonds bearbeiten",
    "admin.portfolio.createNewFund": "Neuen Fonds erstellen",
    "admin.portfolio.fundName": "Fondsname",
    "admin.portfolio.fundNamePlaceholder": "z. B. Umweltwirkungsfonds",
    "admin.portfolio.description": "Beschreibung",
    "admin.portfolio.descriptionPlaceholder":
      "Beschreiben Sie den Zweck und Wirkungsschwerpunkt des Fonds...",
    "admin.portfolio.category": "Kategorie",
    "admin.portfolio.selectCategory": "Kategorie auswählen",
    "admin.portfolio.imageUrl": "Bild-URL",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities":
      "Organisationen auswählen ({{count}} ausgewählt)",
    "admin.portfolio.noCharitiesFound":
      "Keine verifizierten Organisationen gefunden",
    "admin.portfolio.saving": "Wird gespeichert...",
    "admin.portfolio.createFund": "Fonds erstellen",
    "admin.portfolio.updateFund": "Fonds aktualisieren",
    "admin.portfolio.noFundsYet": "Noch keine Portfolio-Fonds",
    "admin.portfolio.noFundsMessage":
      "Erstellen Sie Ihren ersten Fonds, um Organisationen für gebündelte Spenden zusammenzufassen",
    "admin.portfolio.charity": "Organisation",
    "admin.portfolio.charities": "Organisationen",
    "admin.portfolio.createdOn": "Erstellt am {{date}}",
    "admin.portfolio.statusActive": "Aktiv",
    "admin.portfolio.statusPaused": "Pausiert",
    "admin.portfolio.statusArchived": "Archiviert",
    "admin.portfolio.errorLoad": "Daten konnten nicht geladen werden",
    "admin.portfolio.errorArchive": "Fonds konnte nicht archiviert werden",
    "admin.portfolio.fundArchived": "Fonds archiviert",
    "admin.portfolio.fundUpdated": "Fonds aktualisiert",
    "admin.portfolio.fundCreated": "Fonds erstellt",
    "admin.portfolio.errorSave": "Fonds konnte nicht gespeichert werden",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "Organisationsverwaltung",
    "admin.charity.totalCount": "{{count}} insgesamt",
    "admin.charity.allStatuses": "Alle Status",
    "admin.charity.searchPlaceholder": "Nach Name suchen\u2026",
    "admin.charity.colName": "Name",
    "admin.charity.colEin": "Steuer-ID",
    "admin.charity.taxIdDisplay": "Steuer-ID {{value}}",
    "admin.charity.searchByNameEin": "Nach Name oder Steuer-ID suchen…",
    "admin.charity.colCategory": "Kategorie",
    "admin.charity.colStatus": "Status",
    "admin.charity.colSigner": "Kontakt",
    "admin.charity.colJoined": "Beigetreten",
    "admin.charity.colWallet": "Wallet",
    "admin.charity.colActions": "Aktionen",
    "admin.charity.walletNotSet": "Nicht festgelegt",
    "admin.charity.approve": "Genehmigen",
    "admin.charity.reject": "Ablehnen",
    "admin.charity.suspend": "Sperren",
    "admin.charity.reinstate": "Wiederherstellen",
    "admin.charity.statusPending": "Ausstehend",
    "admin.charity.statusVerified": "Verifiziert",
    "admin.charity.statusApproved": "Genehmigt",
    "admin.charity.statusRejected": "Abgelehnt",
    "admin.charity.statusSuspended": "Gesperrt",
    "admin.charity.approveTitle": "Organisation genehmigen",
    "admin.charity.rejectTitle": "Organisation ablehnen",
    "admin.charity.suspendTitle": "Organisation sperren",
    "admin.charity.reinstateTitle": "Organisation wiederherstellen",
    "admin.charity.confirmAction": "Aktion bestätigen",
    "admin.charity.reasonRequired": "Grund (erforderlich)",
    "admin.charity.reasonOptional": "Grund (optional)",
    "admin.charity.saving": "Wird gespeichert\u2026",
    "admin.charity.confirm": "Bestätigen",
    "admin.charity.noResults":
      "Keine Organisationen gefunden, die Ihren Filtern entsprechen.",
    "admin.charity.unnamed": "Unbenannte Organisation",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "Organisationsanfragen",
    "admin.charityRequests.subtitle":
      "Von Spendern eingereichte Anfragen für nicht beanspruchte Organisationen, gruppiert nach Organisation. Organisationen mit dem höchsten Interesse sollten vorrangig kontaktiert werden.",
    "admin.charityRequests.ein": "Steuer-ID",
    "admin.charityRequests.requests": "Anfragen",
    "admin.charityRequests.latestRequester": "Letzter Antragsteller",
    "admin.charityRequests.latestRequest": "Letzte Anfrage",
    "admin.charityRequests.firstRequest": "Erste Anfrage",
    "admin.charityRequests.empty":
      "Es wurden noch keine Organisationsanfragen eingereicht.",
    "admin.charityRequests.errorTitle":
      "Fehler beim Laden der Organisationsanfragen",
    "admin.charityRequests.showing":
      "{{shown}} von {{total}} eindeutigen Organisationen werden angezeigt.",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "Aufsicht über Freiwilligenbestätigung",
    "admin.validation.totalCount": "{{count}} Anfragen insgesamt",
    "admin.validation.pipelineStats": "Pipeline-Statistiken",
    "admin.validation.noStats": "Keine Statistiken verfügbar.",
    "admin.validation.pending": "Ausstehend",
    "admin.validation.approved": "Genehmigt",
    "admin.validation.rejected": "Abgelehnt",
    "admin.validation.expired": "Abgelaufen",
    "admin.validation.avgResponseTime": "Durchschn. Antwortzeit:",
    "admin.validation.expirationRate": "Ablaufrate:",
    "admin.validation.rejectionRate": "Ablehnungsrate:",
    "admin.validation.searchPlaceholder": "Freiwillige, Org. suchen\u2026",
    "admin.validation.requestsTab": "Bestätigungsanfragen",
    "admin.validation.patternsTab": "Verdächtige Muster",
    "admin.validation.colVolunteer": "Freiwillige/r",
    "admin.validation.colOrganisation": "Organisation",
    "admin.validation.colHours": "Stunden",
    "admin.validation.colActivityDate": "Aktivitätsdatum",
    "admin.validation.colHrsPerWeek": "Std./Woche",
    "admin.validation.colTotalRequests": "Anfragen gesamt",
    "admin.validation.override": "Überschreiben",
    "admin.validation.noPatterns": "Keine verdächtigen Muster erkannt.",
    "admin.validation.noRequests": "Keine Bestätigungsanfragen gefunden.",
    "admin.validation.patternsDescription":
      "Freiwillige, die in einem rollierenden 7-Tage-Fenster mehr als den konfigurierten Schwellenwert an Stunden gemeldet haben. Diese Muster können auf Missbrauch des Selbstmeldesystems hinweisen.",
    "admin.validation.overrideTitle": "Bestätigungsanfrage überschreiben",
    "admin.validation.newStatus": "Neuer Status",
    "admin.validation.reasonRequired": "Grund (erforderlich)",
    "admin.validation.reasonPlaceholder":
      "Begründen Sie das Überschreiben dieser Anfrage\u2026",
    "admin.validation.saving": "Wird gespeichert\u2026",
    "admin.validation.confirmOverride": "Überschreibung bestätigen",
    "admin.validation.allStatuses": "Alle Status",
    "admin.validation.colStatus": "Status",
    "admin.validation.colCreated": "Erstellt",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "Transparentes Spenden",
    "home.hero.titleAccent": "Nachhaltige Wirkung",
    "home.hero.description":
      "Radikal transparente Philanthropie für das digitale Zeitalter. Entwickelt für Wirkung, gestützt auf verifizierbare Technologie. Jeder Beitrag nachverfolgbar vom Spender bis zum Empfänger.",
    "home.hero.visionTitle": "Unsere Vision",
    "home.hero.visionText":
      "Give Protocol gestaltet die Zukunft integrer Philanthropie. Wir nutzen fortschrittliche technologische Infrastruktur, um die Kluft zwischen globalem Kapital und lokaler Wirkung zu überbrücken. Durch die Integration nahtloser Unterstützung digitaler Vermögenswerte mit traditionellen Spendenmethoden schaffen wir widerstandsfähige Finanzierungsökosysteme, die einmalige Spenden in dauerhafte Motoren der Unterstützung für die wichtigsten Anliegen der Welt verwandeln.",
    "home.comingSoon": "Demnächst verfügbar",
    "home.readDocs": "Dokumentation lesen",
    "home.features.sectionTitle": "Ihr Zugang zu transparenter Philanthropie",
    "home.features.sectionSubtitle":
      "Multichain-Infrastruktur für nahtloses Spenden — Krypto oder Fiat — mit vollständiger Transparenz",
    "home.features.highEfficiency.title": "Hocheffizientes Spenden",
    "home.features.highEfficiency.description":
      "Spenden Sie direkt an verifizierte Organisationen ohne jede Unklarheit. Unser automatisiertes Hauptbuch bietet Echtzeitverifizierung und stellt sicher, dass Ihre Unterstützung genau dort eingesetzt wird, wo sie am meisten gebraucht wird.",
    "home.features.equityFunds.title": "Gemeinnützige Eigenkapitalfonds",
    "home.features.equityFunds.description":
      "Gehen Sie über Einzelspenden hinaus, indem Sie in intelligent verwaltete Eigenkapitalfonds investieren. Wir setzen ausgefeilte, risikoarme digitale Strategien ein, um Ihr Kapital in einen dauerhaften Finanzierungsstrom zu verwandeln, der gemeinnützige Missionen über Generationen hinweg unterstützt.",
    "home.features.impactFunds.title": "Wirkungsfonds",
    "home.features.impactFunds.description":
      "Bündeln Sie Ressourcen für bestimmte Anliegen. Umwelt, Bildung, Armutsbekämpfung — Ihre Spende wird durch kollektives Handeln verstärkt.",
    "home.features.verifiedOrgs.title": "Verifizierte Organisationen",
    "home.features.verifiedOrgs.description":
      "Durchsuchen Sie jede registrierte Organisation oder achten Sie auf das Verifizierungsabzeichen. Organisationen, die sich unserem Prüfverfahren unterziehen, erhalten eine On-Chain-Verifizierung, der Spender vertrauen können.",
    "home.features.blockchainVerified.title": "Blockchain-verifiziert",
    "home.features.blockchainVerified.description":
      "Seelengebundene Token würdigen Freiwilligenbeiträge. Fähigkeiten, Stunden und Wirkung — alles dauerhaft on-chain erfasst.",
    "home.features.bridgingModes.title": "Spendenarten verbinden",
    "home.features.bridgingModes.description":
      "Ob Sie in USD oder digitalen Vermögenswerten spenden — unsere Multi-Netzwerk-Architektur stellt sicher, dass Ihr Beitrag mit der Geschwindigkeit der modernen Welt übertragen wird.",
    "home.roles.title": "Entwickelt für alle, die die Welt verändern",
    "home.roles.donors.title": "Für Spender",
    "home.roles.donors.item1": "Spenden Sie in Krypto oder Fiat — Ihre Wahl",
    "home.roles.donors.item2": "Teilnahme an der Governance",
    "home.roles.donors.item3": "On-Chain-Reputation aufbauen",
    "home.roles.nonprofits.title": "Für gemeinnützige Organisationen",
    "home.roles.nonprofits.item1": "Zugang zu neuen Spendergruppen",
    "home.roles.nonprofits.item2": "Nachhaltige Finanzierung über CEFs",
    "home.roles.nonprofits.item3": "Verbesserte Transparenzberichterstattung",
    "home.roles.volunteers.title": "Für Freiwillige",
    "home.roles.volunteers.item1": "Verifizierbare Beitragsnachweise",
    "home.roles.volunteers.item2": "Portable Qualifikationsnachweise (SBTs)",
    "home.roles.volunteers.item3": "Auszeichnungen und Anerkennung",
    "home.impact.title": "Geplante Wirkungsfonds",
    "home.impact.environmental.title": "Umwelt-Wirkungsfonds",
    "home.impact.environmental.description":
      "Unterstützung von Aufforstung, Ozeanreinigung und erneuerbaren Energieinitiativen. Gebündelte Spenden, die an verifizierte Umweltorganisationen mit messbarer Wirkung weitergeleitet werden.",
    "home.impact.education.title": "Bildungschancen-Fonds",
    "home.impact.education.description":
      "Bereitstellung von Stipendien, digitalen Lernwerkzeugen und Lehrerfortbildung. Kollektive Finanzierung zur Unterstützung von Bildungsinitiativen in unterversorgten Gemeinden.",
    "home.cta.title": "Bereit, das Spenden zu transformieren?",
    "home.cta.subtitle":
      "Gehören Sie zu den Ersten, die transparente, blockchain-gestützte Philanthropie erleben. Werden Sie Teil unserer Gemeinschaft, die eine bessere Zukunft für gemeinnütziges Spenden gestaltet.",
    "home.cta.explore": "Anliegen erkunden",
    "home.nav.features": "Funktionen",
    "home.nav.impact": "Wirkung",
    "home.nav.charities": "Organisationen",
    "home.nav.volunteer": "Freiwillige",
    "home.footer.brand.tagline":
      "Philanthropie transformieren durch Blockchain-Transparenz und nachhaltige Finanzierung.",
    "home.footer.product.title": "Produkt",
    "home.footer.product.impactFunds": "Wirkungsfonds",
    "home.footer.product.charities": "Für Organisationen",
    "home.footer.product.volunteers": "Für Freiwillige",
    "home.footer.resources.title": "Ressourcen",
    "home.footer.resources.whitepaper": "Whitepaper (Demnächst)",
    "home.footer.resources.blog": "Blog (Demnächst)",
    "home.footer.resources.community": "Community (Demnächst)",
    "home.footer.connect.title": "Kontakt",
    "home.footer.connect.contact": "Kontakt (Demnächst)",
    "home.footer.copyright":
      "Give Protocol. Multichain by Design. Betrieben von Give Protocol-Freiwilligen.",
    "auth.signin.welcomeBack": "Willkommen zurück",
    "auth.signin.subtitle": "Melden Sie sich bei Ihrem Give Protocol-Konto an",
    "auth.signin.emailPlaceholder": "E-Mail",
    "auth.signin.passwordPlaceholder": "Passwort",
    "auth.signin.submitting": "Anmeldung läuft…",
    "auth.signin.withPasskey": "Mit Passkey anmelden",
    "auth.signin.withGoogle": "Weiter mit Google",
    "auth.signin.or": "oder",
    "auth.signin.newToProtocol": "Neu bei Give Protocol?",
    "auth.signin.createAccount": "Konto erstellen →",
    "auth.signin.forgotPasswordLink": "Passwort vergessen? →",
    "auth.signin.sslEncrypted": "TLS-verschlüsselt",
    "auth.signin.modeToggleLabel": "Anmeldemethode",
    "auth.signin.terms": "AGB",
    "auth.signin.privacy": "Datenschutz",
    "auth.panel.headline": "Intelligentes Spenden, transparente Wirkung.",
    "auth.panel.subheadline":
      "Ein Konto. Spenden per Karte oder Krypto. Jeden Betrag on-chain nachverfolgen.",
    "auth.panel.statusLabel": "Protokollstatus · Genesis-Phase",
    "auth.panel.statusDesc": "Die Grundlage für transparentes Spenden schaffen",
    "auth.panel.runsOn": "Läuft auf",
    "auth.wallet.connect": "Wallet verbinden",
    "auth.wallet.connecting": "Wallet wird verbunden…",
    "auth.wallet.signing": "Nachricht wird signiert…",
    "auth.wallet.verifying": "Wird verifiziert…",
    "auth.wallet.openingSession": "Sitzung wird geöffnet…",
    "auth.validation.emailRequired":
      "Bitte geben Sie zuerst Ihre E-Mail-Adresse ein",
    "auth.validation.invalidEmail":
      "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "auth.validation.passwordTooShort":
      "Das Passwort muss mindestens 8 Zeichen lang sein",
    "auth.validation.passwordMismatch": "Die Passwörter stimmen nicht überein",
    "auth.login.welcomeHeading": "Willkommen bei Give Protocol",
    "auth.login.signInOrConnect": "Anmelden oder Verbinden",
    "auth.login.skipToContent": "Zum Anmeldebereich springen",
    "auth.login.donorTitle": "Spender-Anmeldung",
    "auth.login.donorSubtitle":
      "Melden Sie sich an, um auf Ihr Spenden-Dashboard zuzugreifen",
    "auth.login.charityTitle": "Nonprofit-Portal",
    "auth.login.charitySubtitle":
      "Verwalten Sie Ihr Organisationsprofil und Ihre Spenden",
    "auth.login.back": "← Zurück",
    "auth.login.continueDonor": "Weiter als Spender",
    "auth.login.connecting": "Wird verbunden…",
    "auth.login.connectWalletSignIn": "Wallet verbinden & Anmelden",
    "auth.login.newToPlatform": "Neu bei Give Protocol?",
    "auth.login.newDonorSignUp": "Neues Spenderkonto erstellen",
    "auth.login.manageNonprofit": "Ich verwalte ein Nonprofit-Profil",
    "auth.login.nonprofitTrayTitle": "Neu bei Give Protocol?",
    "auth.login.createNonprofitAccount": "Nonprofit-Konto erstellen",
    "auth.login.registerOrg":
      "Registrieren Sie Ihre Organisation bei Give Protocol",
    "auth.login.needHelp": "Brauchen Sie Hilfe?",
    "auth.login.forgotUsernameBtn": "Benutzername vergessen?",
    "auth.login.forgotPasswordBtn": "Passwort vergessen?",
    "auth.donorLogin.mismatch":
      "Spenderkonto nicht gefunden. Diese E-Mail ist als Organisationskonto registriert. Bitte verwenden Sie die Organisations-Anmeldung.",
    "auth.donorLogin.signingIn": "Anmeldung läuft…",
    "auth.donorLogin.redirecting": "Weiterleitung in {{count}}...",
    "auth.donorReg.pleaseWait": "Bitte warten…",
    "auth.donorReg.signUpPasskey": "Mit Passkey registrieren",
    "auth.donorReg.withGoogle": "Weiter mit Google",
    "auth.donorReg.connectWallet": "Wallet verbinden",
    "auth.donorReg.orSetPassword": "Oder Passwort festlegen",
    "auth.donorReg.creating": "Konto wird erstellt...",
    "auth.donorReg.createAccount": "Spenderkonto erstellen",
    "auth.donorReg.privacyNotice":
      "Mit der Erstellung eines Kontos stimmen Sie unseren",
    "auth.donorReg.termsLink": "Nutzungsbedingungen",
    "auth.donorReg.privacyAnd": "zu und erkennen unsere",
    "auth.donorReg.privacyLink": "Datenschutzrichtlinie",
    "auth.charityLogin.mismatch":
      "Diese E-Mail ist als Spenderkonto registriert. Bitte melden Sie sich über das Spenderportal an.",
    "auth.charityLogin.signingIn": "Anmeldung läuft...",
    "auth.charityLogin.or": "oder",
    "auth.charityLogin.connecting": "Wird verbunden...",
    "auth.charityLogin.connectWallet": "Wallet verbinden",
    "auth.forgot.resetPassword": "Passwort zurücksetzen",
    "auth.forgot.forgotUsername": "Benutzername vergessen",
    "auth.forgot.passwordDesc":
      "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
    "auth.forgot.usernameDesc":
      "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen Ihren Benutzernamen.",
    "auth.forgot.passwordSuccess":
      "Anweisungen zum Zurücksetzen des Passworts wurden an Ihre E-Mail gesendet",
    "auth.forgot.usernameSuccess":
      "Erinnerung an Ihren Benutzernamen wurde an Ihre E-Mail gesendet",
    "auth.forgot.checkEmail": "Prüfen Sie Ihre E-Mails",
    "auth.forgot.backToSignIn": "Zurück zur Anmeldung",
    "auth.forgot.emailPlaceholder": "E-Mail-Adresse eingeben",
    "auth.forgot.genericError":
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "auth.forgot.sending": "Wird gesendet...",
    "auth.forgot.sendResetLink": "Link zum Zurücksetzen senden",
    "auth.forgot.sendUsername": "Benutzername senden",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "Organisationsname",
    "auth.orgSearch.searchPlaceholder": "Nach Organisationsname suchen...",
    "auth.orgSearch.countryLabel": "Land",
    "auth.orgSearch.allCountries": "Alle Länder",
    "auth.orgSearch.searchPrompt":
      "Durchsuchen Sie unsere Datenbank, um Ihre Organisation zu finden und zu beanspruchen.",
    "auth.orgSearch.noResults": "Keine Organisationen gefunden.",
    "auth.orgSearch.loadMore": "Weitere Ergebnisse laden",
    "auth.orgSearch.cantFind": "Ihre Organisation nicht gefunden?",
    "auth.orgSearch.registerManually": "Manuell registrieren",
    "charity.claim.orgDetails": "Organisationsdetails (aus dem Register)",
    "charity.claim.orgNameLabel": "Name",
    "charity.claim.einLabel": "Steuer-ID",
    "charity.claim.locationLabel": "Standort",
    "charity.claim.contactInfo": "Kontaktinformationen",
    "charity.claim.contactName": "Kontaktname",
    "charity.claim.contactEmail": "Kontakt-E-Mail",
    "charity.claim.accountSecurity": "Kontosicherheit",
    "charity.claim.password": "Passwort",
    "charity.claim.confirmPassword": "Passwort bestätigen",
    "charity.claim.backToSearch": "Zurück zur Suche",
    "charity.claim.creating": "Konto wird erstellt...",
    "charity.claim.submit": "Organisation beanspruchen",
    "charity.claim.validation.name":
      "Der Name muss zwischen 2 und 100 Zeichen lang sein",
    "charity.claim.validation.email":
      "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "charity.claim.validation.password":
      "Das Passwort muss mindestens 8 Zeichen lang sein",
    "charity.claim.validation.confirmPassword":
      "Die Passwörter stimmen nicht überein",
    "charity.claim.validation.fix":
      "Bitte korrigieren Sie die Validierungsfehler",
    "charity.claim.useAsPublicEmail":
      "Meine E-Mail als öffentliche Kontakt-E-Mail der Organisation verwenden",
    "charity.claim.publicContactEmail":
      "Öffentliche Kontakt-E-Mail der Organisation",
    "charity.claim.privacyNotice":
      "Ihre persönliche Unterzeichner-E-Mail/Telefonnummer wird nur zur Verifizierung verwendet und ist für andere Plattformnutzer nicht sichtbar. Die öffentliche Kontakt-E-Mail wird in Ihrem Organisationsprofil angezeigt.",
    "charity.claim.secondContactTitle": "Zweitkontakt",
    "charity.claim.secondContactName": "Name des Zweitkontakts",
    "charity.claim.secondContactEmail": "E-Mail-Adresse des Zweitkontakts",
    "charity.claim.secondContactHint":
      "Eine andere Person, die benachrichtigt wird, wenn sich die Wallet- oder Auszahlungsdaten Ihrer Organisation ändern.",
    "charity.claim.validation.secondEmailDistinct":
      "Die E-Mail-Adresse des Zweitkontakts muss sich von der Haupt-E-Mail-Adresse unterscheiden",
    "charity.claim.error.creation": "Kontoerstellung fehlgeschlagen",
    "charity.claim.error.generic": "Konto konnte nicht erstellt werden",
    "charity.vetting.orgDetails": "Organisationsdetails",
    "charity.vetting.orgName": "Organisationsname",
    "charity.vetting.description": "Beschreibung",
    "charity.vetting.taxId": "Steuer- oder Registrierungsnummer",
    "charity.vetting.countryLabel": "Land",
    "charity.vetting.selectCountry": "Land auswählen",
    "charity.vetting.address": "Adresse",
    "charity.vetting.streetAddress": "Straße und Hausnummer",
    "charity.vetting.city": "Stadt",
    "charity.vetting.state": "Bundesland/Provinz",
    "charity.vetting.postalCode": "Postleitzahl",
    "charity.vetting.contactInfo": "Kontaktinformationen",
    "charity.vetting.contactName": "Kontaktname",
    "charity.vetting.contactEmail": "Kontakt-E-Mail",
    "charity.vetting.accountSecurity": "Kontosicherheit",
    "charity.vetting.password": "Passwort",
    "charity.vetting.confirmPassword": "Passwort bestätigen",
    "charity.vetting.submitting": "Antrag wird eingereicht...",
    "charity.vetting.submit":
      "Antrag als gemeinnützige Organisation einreichen",
    "charity.vetting.validation.orgName":
      "Der Organisationsname muss zwischen 2 und 100 Zeichen lang sein",
    "charity.vetting.validation.contactName":
      "Der Kontaktname muss zwischen 2 und 100 Zeichen lang sein",
    "charity.vetting.validation.email":
      "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "charity.vetting.validation.password":
      "Das Passwort muss mindestens 8 Zeichen lang sein",
    "charity.vetting.validation.confirmPassword":
      "Die Passwörter stimmen nicht überein",
    "charity.vetting.validation.description": "Beschreibung ist erforderlich",
    "charity.vetting.validation.category": "Kategorie ist erforderlich",
    "charity.vetting.validation.taxId": "Steuer-ID ist erforderlich",
    "charity.vetting.validation.streetAddress":
      "Straße und Hausnummer sind erforderlich",
    "charity.vetting.validation.city": "Stadt ist erforderlich",
    "charity.vetting.validation.country": "Land ist erforderlich",
    "charity.vetting.validation.fix":
      "Bitte korrigieren Sie die Validierungsfehler",
    "charity.vetting.error.generic": "Antrag konnte nicht eingereicht werden",
    "charity.vetting.privacyNotice":
      "Mit dem Einreichen dieses Antrags stimmen Sie unseren",
    "charity.vetting.termsLink": "Nutzungsbedingungen",
    "charity.vetting.privacyAnd": "zu und erkennen unsere",
    "charity.vetting.privacyLink": "Datenschutzrichtlinie",
    "common.email": "E-Mail",
    "common.password": "Passwort",
    "common.confirmPassword": "Passwort bestätigen",
    "footer.brand.tagline":
      "Wir beseitigen Hürden für nachhaltiges gemeinnütziges Spenden.",
    "footer.resources.title": "Ressourcen",
    "footer.resources.faq": "FAQ",
    "footer.resources.about": "Über uns",
    "footer.legal.title": "Rechtliches",
    "footer.legal.terms": "Nutzungsbedingungen",
    "footer.legal.privacy": "Datenschutzrichtlinie",
    "footer.legal.cookiePreferences": "Cookie-Einstellungen",
    "consent.banner.ariaLabel": "Cookie-Einwilligung",
    "consent.banner.body":
      "Wir verwenden Google Analytics 4 (Google LLC, USA) und Sentry (Functional Software, USA/EU), um die App-Nutzung zu verstehen und Fehler zu erkennen. Es werden keine E-Mail-Adressen, Wallet-Adressen oder Spendernamen weitergegeben. Sie können Ihre Einwilligung jederzeit widerrufen.",
    "consent.banner.privacyLink": "Datenschutzrichtlinie",
    "consent.banner.acceptAll": "Alle akzeptieren",
    "consent.banner.decline": "Nicht-essenzielle ablehnen",
    "consent.banner.customize": "Anpassen",
    "consent.modal.title": "Cookie-Einstellungen",
    "consent.modal.essentialTitle": "Essenziell",
    "consent.modal.essentialDesc":
      "Erforderlich für grundlegende Website-Funktionen wie Navigation und Authentifizierung. Kann nicht deaktiviert werden.",
    "consent.modal.essentialAlwaysOn": "Essenzielle Cookies — immer aktiv",
    "consent.modal.analyticsTitle":
      "Analyse (Google Analytics 4 · USA, Sentry · USA/EU)",
    "consent.modal.analyticsDesc":
      "Analyse-Cookies helfen uns zu verstehen, welche Seiten besucht werden und wie Nutzer durch die App navigieren. Wir verwenden Google Analytics 4 \u2014 Sitzungskennungen, Seiten-URLs, Geräte-/Browser-Metadaten, ungefährer Standort aus anonymisierter IP (Google LLC, USA; SCCs + EU\u2013US Data Privacy Framework). Sentry \u2014 anonymisierte Fehlerprotokolle und Browser-Metadaten für Zuverlässigkeitsüberwachung (Functional Software, EU/USA; Übertragungsmechanismus ausstehend). Es werden keine E-Mail-Adressen, Wallet-Adressen oder Spendernamen an die Auftragsverarbeiter weitergegeben.",
    "consent.modal.analyticsOn": "Analyse & Fehleraufzeichnung — an",
    "consent.modal.analyticsOff": "Analyse & Fehleraufzeichnung — aus",
    "consent.modal.cancel": "Abbrechen",
    "consent.modal.save": "Einstellungen speichern",
    "footer.connect.title": "Kontakt",
    "footer.copyright": "Give Protocol. Alle Rechte vorbehalten.",
    "nav.signIn": "Anmelden",
    "nav.signOut": "Abmelden",
    "nav.privacy": "Datenschutz",
    "auth.signup.heading": "Erstellen Sie Ihr Konto",
    "auth.signup.subtitle":
      "Werden Sie Teil der Bewegung für transparentes Spenden",
    "auth.signup.displayName": "Anzeigename",
    "auth.signup.emailPlaceholder": "E-Mail",
    "auth.signup.passwordPlaceholder": "Passwort",
    "auth.signup.confirmPasswordPlaceholder": "Passwort bestätigen",
    "auth.signup.submit": "Konto erstellen",
    "auth.signup.submitting": "Konto wird erstellt…",
    "auth.signup.withPasskey": "Mit Passkey registrieren",
    "auth.signup.withGoogle": "Weiter mit Google",
    "auth.signup.connectWallet": "Wallet verbinden",
    "auth.signup.orSetPassword": "Oder Passwort festlegen",
    "auth.signup.alreadyHaveAccount": "Haben Sie bereits ein Konto?",
    "auth.signup.signInLink": "Anmelden",
    "auth.signup.manageNonprofit":
      "Verwalten Sie eine gemeinnützige Organisation?",
    "auth.signup.trustText": "Ihre Daten werden geschützt durch",
    "auth.signup.and": "und",
    "auth.signup.privacyPolicy": "Datenschutzrichtlinie",
    "auth.signup.panel.headline": "Spenden, die Sie verifizieren können.",
    "browse.hero.title": "Spenden, on-chain verifiziert.",
    "browse.hero.subtitle":
      "Entdecken Sie geprüfte Anliegen, spenden Sie per Karte oder digitalen Vermögenswerten und sehen Sie den greifbaren Einfluss Ihrer Zeit und Ressourcen.",
    "browse.stats.networks": "Unterstützte Netzwerke",
    "browse.stats.sectors": "Gemeinnützige Bereiche",
    "browse.stats.verifiedOrgs": "Verifizierte Organisationen",
    "browse.stats.volunteerHours": "Freiwilligenstunden",
    "browse.verified": "Verifiziert",
    "browse.donate": "Spenden",
    "browse.viewProfile": "Profil ansehen",
    "browse.filter.ariaLabel": "Organisationen filtern",
    "browse.filter.searchAria": "Organisationen suchen",
    "browse.filter.locationAria": "Standort suchen",
    "browse.results.ariaLabel": "Organisationsergebnisse",
    "browse.tabs.charities": "Organisationen",
    "browse.tabs.causes": "Anliegen",
    "browse.tabs.funds": "Portfolio-Fonds",
    "browse.tabs.ariaLabel": "Kategorien durchsuchen",
    "browse.featured.heading": "Ausgewählte Organisationen",
    "browse.featured.ariaLabel": "Ausgewählte Organisationen",
    "browse.featured.nextAria": "Nächste ausgewählte Organisationen",
    "browse.causes.heading": "Ausgewählte Anliegen",
    "browse.causes.ariaLabel": "Ausgewählte Anliegen",
    "browse.causes.badge": "Anliegen",
    "browse.causes.raised": "gesammelt",
    "browse.causes.percentOf": "% von",
    "browse.causes.by": "von",
    "browse.causes.supportCta": "Dieses Anliegen unterstützen",
    "browse.causes.giveCta": "Spenden",
    "browse.causes.nextAria": "Nächste ausgewählte Anliegen",
    "browse.funds.heading": "Portfolio-Fonds",
    "browse.funds.ariaLabel": "Portfolio-Fonds",
    "browse.funds.badge": "Portfolio-Fonds",
    "browse.funds.charity": "Organisation",
    "browse.funds.charities": "Organisationen",
    "browse.funds.donateCta": "An Fonds spenden",
    "browse.funds.nextAria": "Nächste Portfolio-Fonds",
    "portfolio.notFound.title": "Portfolio-Fonds nicht gefunden",
    "portfolio.notFound.body":
      "Der gesuchte Portfolio-Fonds existiert nicht oder ist nicht mehr aktiv.",
    "portfolio.supportedOrgs": "Unterstützte Organisationen",
    "browse.charity.einLabel": "Steuer-ID",
    "browse.charity.einDisplay": "Steuer-ID: {{value}}",
    "browse.charity.nteeLabel": "Sektorcode",
    "browse.charity.deductibilityLabel": "Absetzbarkeit",
    "browse.charity.onPlatform": "Auf der Plattform",
    "browse.charity.loading": "Wird geladen…",
    "browse.charity.loadMore": "Mehr laden",
    "browse.filter.searchPlaceholder": "Wohltätigkeitsorganisationen suchen...",
    "browse.filter.locationPlaceholder": "Stadt, Bundesland oder Land...",
    "browse.whyGiveProtocol.heading": "Warum Give Protocol?",
    "browse.whyGiveProtocol.verified.title":
      "Verifizierte gemeinnützige Organisationen",
    "browse.whyGiveProtocol.verified.description":
      "Jede Organisation wird vor der Aufnahme auf der Plattform mit öffentlichen Registern abgeglichen.",
    "browse.whyGiveProtocol.onchain.title": "On-Chain-Transparenz",
    "browse.whyGiveProtocol.onchain.description":
      "Spenden werden auf der Blockchain aufgezeichnet, damit Sie Ihre Wirkung von der Wallet bis zum Zweck nachverfolgen können.",
    "browse.whyGiveProtocol.volunteer.title": "Geben Sie Zeit, nicht nur Geld",
    "browse.whyGiveProtocol.volunteer.description":
      "Ehrenamtsstunden werden von Organisationen verifiziert und fließen in Ihre Protokoll-Reputation ein.",
    "browse.news.heading": "Plattform-Nachrichten",
    "admin.news.deleteConfirmBody": "„{{title}}“ wird dauerhaft entfernt. Dies kann nicht rückgängig gemacht werden.",
    "admin.news.deleteConfirmTitle": "Nachricht löschen?",
    "admin.news.saveFailed": "Ihre Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    "admin.news.urlHelp": "Optional. Leer lassen, um die Nachricht ohne Link anzuzeigen.",
    "admin.news.urlInvalid": "Geben Sie eine vollständige https://-Adresse oder einen mit / beginnenden Pfad ein.",
    "browse.carousel.error": "Dieser Bereich konnte nicht geladen werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.",
    "browse.carousel.goToPage": "Zu Seite {{page}}",
    "browse.carousel.pageLabel": "Seite {{current}} von {{total}}",
    "browse.carousel.pause": "Automatischen Wechsel anhalten",
    "browse.carousel.play": "Automatischen Wechsel fortsetzen",
    "browse.causes.empty": "Noch keine Anliegen verfügbar. Schauen Sie bald wieder vorbei!",
    "browse.causes.prevAria": "Vorherige hervorgehobene Anliegen",
    "browse.causes.searchPlaceholder": "Anliegen suchen...",
    "browse.causes.subheading": "Unterstützen Sie konkrete Projekte mit echter Wirkung.",
    "browse.charity.registryIdDisplay": "Registernummer: {{value}}",
    "browse.featured.empty": "Noch keine hervorgehobenen Organisationen. Nutzen Sie die Suche oben, um eine Wohltätigkeitsorganisation zu finden.",
    "browse.featured.prevAria": "Vorherige hervorgehobene Organisationen",
    "browse.featured.subheading": "Ein wechselnder Blick auf verifizierte Wohltätigkeitsorganisationen bei Give Protocol.",
    "browse.filter.addLocation": "Standort hinzufügen",
    "browse.filter.impactNotice": "Die Filterung nach Wirkungsort ist noch nicht verfügbar, daher werden die Ergebnisse nicht nach Wirkungsort eingegrenzt.",
    "browse.filter.locationHint": "Drücken Sie die Eingabetaste oder wählen Sie „Hinzufügen“, um einen Standort anzuwenden.",
    "browse.filter.minChars": "Geben Sie mindestens 2 Zeichen ein, um zu suchen.",
    "browse.funds.empty": "Noch keine Portfolio-Fonds verfügbar. Schauen Sie bald wieder vorbei!",
    "browse.funds.prevAria": "Vorherige Portfolio-Fonds",
    "browse.funds.searchPlaceholder": "Portfolio-Fonds suchen...",
    "browse.funds.subheading": "Kuratierte Spendenportfolios, die Spenden auf verifizierte Wohltätigkeitsorganisationen verteilen.",
    "browse.registry.badge": "{{registry}}-registriert",
    "browse.results.empty": "Keine Organisationen entsprechen dieser Suche. Versuchen Sie ein anderes Stichwort oder fügen Sie einen Standortfilter hinzu.",
    "browse.results.error": "Die Suche konnte nicht ausgeführt werden. Bitte versuchen Sie es erneut.",
    "browse.search.noMatches": "Keine Treffer für „{{query}}“.",
    "browse.category.A": "Kunst & Kultur",
    "browse.category.B": "Bildung",
    "browse.category.C": "Umwelt",
    "browse.category.D": "Tierschutz",
    "browse.category.E": "Gesundheit",
    "browse.category.F": "Psychische Gesundheit",
    "browse.category.G": "Medizinische Forschung",
    "browse.category.H": "Biomedizinische Forschung",
    "browse.category.I": "Recht & Kriminalität",
    "browse.category.J": "Beschäftigung",
    "browse.category.K": "Ernährung",
    "browse.category.L": "Wohnen",
    "browse.category.M": "Öffentliche Sicherheit",
    "browse.category.N": "Freizeit & Sport",
    "browse.category.O": "Jugendförderung",
    "browse.category.P": "Soziale Dienste",
    "browse.category.Q": "International",
    "browse.category.R": "Bürgerrechte",
    "browse.category.S": "Gemeindeentwicklung",
    "browse.category.T": "Philanthropie",
    "browse.category.U": "Wissenschaft & Technologie",
    "browse.category.V": "Sozialwissenschaften",
    "browse.category.W": "Öffentliche Politik",
    "browse.category.X": "Religion",
    "browse.category.Y": "Gegenseitiger Nutzen",
    "browse.category.default": "Gemeinnützige Organisation",
    "cause.causes": "Anliegen",
    "cause.createNew": "Neu erstellen",
    "cause.noCausesTitle": "Noch keine Anliegen",
    "cause.name": "Name",
    "cause.description": "Beschreibung",
    "cause.category": "Kategorie",
    "cause.targetAmount": "Zielbetrag",
    "cause.headerImage": "Headerbild",
    "cause.impact": "Wirkung",
    "cause.impactHelp":
      "Beschreiben Sie die erwartete Wirkung dieses Anliegens.",
    "cause.location": "Standort",
    "cause.timeline": "Zeitplan",
    "cause.partners": "Partner",
    "cause.limitReached": "Anliegen-Limit erreicht",
    "impact.statistics": "Wirkungsstatistiken",
    "impact.statLabel": "Bezeichnung",
    "impact.statValue": "Wert",
    "impact.missionStatement": "Leitbild",
    "impact.missionPlaceholder": "Unsere Mission ist es…",
    "impact.highlights": "Wirkungshöhepunkte",
    "impact.highlight": "Wirkungshöhepunkt",
    "impact.addHighlight": "Höhepunkt hinzufügen",
    "impact.profile": "Wirkungsprofil",
    "impact.loadError": "Wirkungsprofil konnte nicht geladen werden",
    "impact.saveError": "Wirkungsprofil konnte nicht gespeichert werden",
    "impact.saveSuccess": "Wirkungsprofil erfolgreich gespeichert",
    "organization.yearFounded": "Gründungsjahr",
    "organization.address": "Adresse",
    "organization.street": "Straße und Hausnummer",
    "organization.city": "Stadt",
    "organization.stateProvince": "Bundesland/Provinz",
    "organization.postalCode": "Postleitzahl",
    "organization.country": "Land",
    "organization.contactInfo": "Kontaktinformationen",
    "organization.phone": "Telefon",
    "organization.email": "E-Mail",
    "organization.website": "Webseite",
    "organization.socialMedia": "Soziale Medien",
    "organization.publicFeed": "Öffentlicher Feed",
    "organization.communityMedia": "Community & Medien",
    "organization.profile": "Organisationsprofil",
    "organization.loadError": "Organisationsprofil konnte nicht geladen werden",
    "organization.saveError":
      "Organisationsprofil konnte nicht gespeichert werden",
    "common.remove": "Entfernen",
    "common.saveChanges": "Änderungen speichern",
    "dashboard.thisMonth": "Dieser Monat",
    "dashboard.verified": "Verifizierte Freiwillige",
    "dashboard.hoursLogged": "Erfasste Stunden",
    "dashboard.endorsements": "Empfehlungen",
    "dashboard.organizationsHelped": "Unterstützte Organisationen",
    "dashboard.yourOrganizationsHelped": "Ihre unterstützten Organisationen",
    "transactions.createCampaign": "Erstellen Sie Ihre erste Kampagne",
    "contributions.emptyTitle": "Ihre Spendenreise beginnt hier",
    "contributions.browseCharities": "Organisationen durchsuchen",
    "charity.profile.verified501c3": "Verifizierte gemeinnützige Organisation",
    "charity.profile.verified501c3Tooltip":
      "Registrierte 501(c)(3) — Spenden können in den USA steuerlich absetzbar sein",
    "charity.profile.statusClaimed": "Beansprucht",
    "charity.profile.statusUnclaimed":
      "Nicht beansprucht — nur öffentliche Registerdaten",
    "charity.profile.statusIrsVerified":
      "IRS-verifizierte gemeinnützige Organisation",
    "charity.profile.requestWidget.unclaimedBody":
      "Diese Organisation hat ihr Profil bei Give Protocol noch nicht beansprucht. Spenden werden verfügbar, sobald die Organisation ihr Profil beansprucht und die Wallet-Einrichtung abgeschlossen hat.",
    "charity.profile.rowEin": "Steuer-ID",
    "charity.profile.rowName": "Name",
    "charity.profile.rowLocation": "Standort",
    "charity.profile.rowRulingYear": "Registrierungsjahr",
    "charity.profile.rowNteeCode": "Sektorcode",
    "charity.profile.rowDeductibility": "Absetzbarkeit",
    "charity.profile.rowAffiliation": "Zugehörigkeit",
    "charity.profile.rowClassification": "Klassifizierung",
    "charity.profile.rowFoundation": "Stiftungstyp",
    "charity.profile.rowActivityCodes": "Aktivitätscodes",
    "charity.profile.rowOrgType": "Organisationstyp",
    "charity.profile.rowSubsection": "Unterabschnitt",
    "charity.profile.rowStatus": "Status",
    "charity.profile.registryRecord": "Öffentlicher Registereintrag",
    "charity.profile.einDisplay": "Steuer-ID",
    "charity.profile.charityNotFoundByTaxId":
      "Wir konnten keine Organisation mit dieser Steuer-ID finden.",
    "charity.profile.registeredNonprofit":
      "Registrierte gemeinnützige Organisation",
    "charity.profile.registeredYear": "Registriert {{year}}",
    "charity.profile.shareAria": "Teilen",
    "charity.profile.copied": "Kopiert!",
    "charity.profile.about": "Über",
    "charity.profile.claimProfile": "Dieses Profil beanspruchen",
    "charity.profile.noDescription": "Keine Beschreibung verfügbar.",
    "charity.profile.toAddOne": "um eine hinzuzufügen.",
    "charity.profile.contact": "Kontakt",
    "charity.profile.donate.support": "Unterstützen",
    "charity.profile.donate.walletUnset":
      "Diese Organisation hat noch keine offizielle Empfangswallet eingerichtet.",
    "charity.profile.donate.walletPending":
      "Diese Organisation richtet gerade ihre Wallet ein — Spenden sind vorübergehend nicht verfügbar.",
    "charity.profile.donate.walletLegacy":
      "Diese Organisation verwendet eine ältere Wallet-Adresse.",
    "charity.profile.donate.feeNote":
      "0% Plattformgebühr auf direkte Spenden. Netzwerkgebühren fallen an.",
    "charity.profile.donate.jurisdictionUnavailable":
      "Spenden an Wohltätigkeitsorganisationen außerhalb der Vereinigten Staaten sind auf Give Protocol noch nicht verfügbar.",
    "portfolio.title": "Portfolio-Fonds",
    "settings.displayPreferences": "Anzeigeeinstellungen",
    "settings.theme": "Design",
    "settings.light": "Hell",
    "settings.dark": "Dunkel",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "Ich verstehe, dass mein Spendeneintrag mich mit {{charity}} verknüpft. Soweit dies auf eine religiöse, politische oder philosophische Zugehörigkeit hinweisen könnte, stimme ich ausdrücklich zu, dass Give Protocol diesen Eintrag verarbeitet, um meine Spende abzuwickeln und zu verwalten.",
    "donation.art9Consent.label": "Einwilligung zur Spendendatenverarbeitung",
    "donation.art9Consent.required":
      "Sie müssen der Verarbeitung der Spendendaten zustimmen, um fortzufahren.",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "Als technische Maßnahme gemäß Artikel 32 der DSGVO protokollieren und überwachen wir den administrativen Zugriff auf personenbezogene Daten — einschließlich der durchgeführten Aktion und des Zeitpunkts — um unbefugten Zugriff zu erkennen, Rechenschaftspflicht nachzuweisen und Ereignisse im unwahrscheinlichen Fall einer Verletzung des Schutzes personenbezogener Daten (Artikel 34) zu rekonstruieren. Personenbezogene Daten von Spendern werden nicht in diese Verwaltungszugriffsprotokolle dupliziert. Verwaltungszugriffsprotokolle unterscheiden sich von den in §7.1 beschriebenen Authentifizierungs- und Sicherheitsprotokollen; ihre Aufbewahrungsfrist wird durch unser internes Verzeichnis von Verarbeitungstätigkeiten geregelt.",

    // Remaining i18n keys — batch translation

    // Admin - Audit trail
    "admin.auditTrail.filterByAction": "Nach Aktion filtern",
    "admin.auditTrail.allActions": "Alle Aktionen",
    "admin.auditTrail.action.charityStatusChange":
      "Statusänderung der Organisation",
    "admin.auditTrail.action.userStatusChange": "Statusänderung des Benutzers",
    "admin.auditTrail.action.donationFlag": "Spende markiert",
    "admin.auditTrail.action.donationFlagResolve":
      "Markierung der Spende aufgehoben",
    "admin.auditTrail.action.validationOverride": "Bestätigung überschrieben",
    "admin.auditTrail.action.configChange": "Konfigurationsänderung",
    "admin.auditTrail.action.verificationApprove": "Verifizierung genehmigt",
    "admin.auditTrail.action.verificationReject": "Verifizierung abgelehnt",
    "admin.auditTrail.action.charitySuspend": "Organisation gesperrt",
    "admin.auditTrail.action.charityReinstate":
      "Organisation wiederhergestellt",
    "admin.auditTrail.action.userSuspend": "Benutzer gesperrt",
    "admin.auditTrail.action.userReinstate": "Benutzer wiederhergestellt",
    "admin.auditTrail.action.userBan": "Benutzer verbannt",
    "admin.auditTrail.action.viewPii": "PII angezeigt",
    "admin.auditTrail.action.viewPiiList": "PII-Liste angezeigt",
    "admin.auditTrail.viewedEntity":
      "Admin {{adminId}} hat {{entityType}} {{entityId}} angezeigt",
    "admin.auditTrail.viewedList":
      "Admin {{adminId}} hat die {{entityType}}-Liste angezeigt (Seite {{page}}, Filter: {{filters}})",
    "admin.auditTrail.viewedListNoFilters":
      "Admin {{adminId}} hat die {{entityType}}-Liste angezeigt (Seite {{page}})",

    // Admin - News
    "admin.actions.platformNews": "Plattform-Neuigkeiten",
    "admin.actions.platformNewsDesc":
      "Neuigkeiten auf der Durchsuchen-Seite verwalten",
    "admin.news.activate": "{{title}} veröffentlichen",
    "admin.news.activated": "Neuigkeit veröffentlicht",
    "admin.news.activeLabel": "Veröffentlicht (öffentlich sichtbar)",
    "admin.news.categoryLabel": "Kategorie",
    "admin.news.contentLabel": "Inhalt / Auszug",
    "admin.news.contentPlaceholder": "Kurzbeschreibung der Neuigkeit...",
    "admin.news.createNews": "Neuigkeit erstellen",
    "admin.news.createNewsBtn": "Neuigkeit erstellen",
    "admin.news.created": "Neuigkeit erstellt",
    "admin.news.dateLabel": "Veröffentlichungsdatum",
    "admin.news.deactivate": "{{title}} deaktivieren",
    "admin.news.deactivated": "Neuigkeit ausgeblendet",
    "admin.news.deleteItem": "{{title}} löschen",
    "admin.news.deleted": "Neuigkeit gelöscht",
    "admin.news.editItem": "{{title}} bearbeiten",
    "admin.news.editNews": "Neuigkeit bearbeiten",
    "admin.news.imageLabel": "Bild-URL (optional)",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "Inaktiv",
    "admin.news.newItem": "Neuer Eintrag",
    "admin.news.noItemsMessage":
      "Erstellen Sie Ihre erste Neuigkeit, um Updates mit Ihrer Community zu teilen",
    "admin.news.noItemsYet": "Noch keine Neuigkeiten",
    "admin.news.publishedOn": "Veröffentlicht am {{date}}",
    "admin.news.saving": "Wird gespeichert...",
    "admin.news.subtitle":
      "Verwalten Sie Neuigkeiten, die auf der öffentlichen Durchsuchen-Seite angezeigt werden",
    "admin.news.title": "Plattform-Neuigkeiten",
    "admin.news.titleLabel": "Titel",
    "admin.news.titlePlaceholder": "z. B. Vierteljährlicher Wirkungsbericht",
    "admin.news.updateNews": "Neuigkeit aktualisieren",
    "admin.news.updated": "Neuigkeit aktualisiert",
    "admin.news.urlLabel": "Link-URL",
    "admin.news.urlPlaceholder": "https://example.org/article",

    // Charity - wallet badge
    "charity.walletBadge.institutionalLabel": "Verwahrt bei {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "Spenden gehen an ein Wallet, das von einem qualifizierten institutionellen Verwahrer gehalten wird.",
    "charity.walletBadge.safeLabel":
      "Multisig-Treasury · {{threshold}}-von-{{count}} Unterzeichnern",
    "charity.walletBadge.safeTooltip":
      "Spenden gehen an ein Multisig-Wallet, das mehrere Genehmigungen erfordert, bevor Gelder bewegt werden können.",

    // Wallet - EOA
    "wallet.eoa.chain": "Netzwerk",
    "wallet.eoa.checkAuthorized":
      "Ich bin von meiner Organisation befugt, dieses Wallet als Empfangsadresse für wohltätige Spenden festzulegen.",
    "wallet.eoa.checkRisk":
      "Ich verstehe, dass ein Wallet mit nur einem Unterzeichner ein höheres Risiko als ein Multisig birgt und dass der Verlust des privaten Schlüssels den dauerhaften Verlust der Gelder bedeutet.",
    "wallet.eoa.confirmSubtitle":
      "Bitte bestätigen Sie Folgendes, bevor Sie dieses Wallet registrieren.",
    "wallet.eoa.confirmTitle": "Endgültige Bestätigung",
    "wallet.eoa.connectFirst": "Bitte verbinden Sie zuerst Ihr Wallet.",
    "wallet.eoa.connectWallet": "Wallet verbinden",
    "wallet.eoa.missingSignature":
      "Signatur fehlt. Bitte gehen Sie zurück und signieren Sie erneut.",
    "wallet.eoa.proceedAnyway": "Ich verstehe, fortfahren",
    "wallet.eoa.register": "Wallet registrieren",
    "wallet.eoa.registering": "Wird registriert...",
    "wallet.eoa.rejected": "Signaturanfrage wurde abgelehnt.",
    "wallet.eoa.riskParagraph1":
      "Ein Wallet mit nur einem Unterzeichner (EOA) wird von einem einzigen privaten Schlüssel kontrolliert. Geht dieser Schlüssel verloren, wird er gestohlen oder kompromittiert, sind alle an dieses Wallet gesendeten Gelder dauerhaft unwiederbringlich.",
    "wallet.eoa.riskParagraph2":
      "Für Organisationsgelder empfehlen wir dringend, stattdessen ein Multisig-Safe-Wallet zu verwenden. Multisig-Wallets erfordern mehrere Genehmigungen für jede Transaktion und schützen so vor einzelnen Fehlerquellen.",
    "wallet.eoa.riskParagraph3":
      "Mit dem Fortfahren erkennen Sie an, dass Give Protocol nicht für einen Verlust von Geldern durch Kompromittierung, Verlust oder Missmanagement des privaten Schlüssels verantwortlich ist.",
    "wallet.eoa.riskTitle":
      "Wallet mit nur einem Unterzeichner: wichtige Risiken",
    "wallet.eoa.signError":
      "Nachricht konnte nicht signiert werden. Bitte versuchen Sie es erneut.",
    "wallet.eoa.signMessage": "Verifizierungsnachricht signieren",
    "wallet.eoa.signSubtitle":
      "Verbinden Sie Ihr Wallet und signieren Sie eine Nachricht, um nachzuweisen, dass Sie diese Adresse kontrollieren.",
    "wallet.eoa.signTitle": "Verbinden und signieren",
    "wallet.eoa.useMultisig": "Stattdessen ein Multisig verwenden",
    "wallet.eoa.walletConnection": "Wallet",
    "wallet.eoa.walletToRegister": "Zu registrierendes Wallet",

    // Wallet - Institutional
    "wallet.institutional.address": "Wallet-Adresse",
    "wallet.institutional.attestation": "Bestätigungsdokument",
    "wallet.institutional.attestationHelp":
      "Laden Sie eine PDF-, JPEG- oder PNG-Datei hoch (max. 10 MB), die Ihre Verwahrungsbeziehung nachweist.",
    "wallet.institutional.backToWallets": "Zurück zu den Wallets",
    "wallet.institutional.chain": "Netzwerk",
    "wallet.institutional.chooseFile":
      "Datei auswählen oder per Drag & Drop ablegen",
    "wallet.institutional.custodian": "Verwahrer",
    "wallet.institutional.fileTooLarge":
      "Die Datei muss kleiner als 10 MB sein.",
    "wallet.institutional.invalidAddress":
      "Bitte geben Sie eine gültige Ethereum-Adresse ein (0x...)",
    "wallet.institutional.invalidFileType":
      "Bitte laden Sie eine PDF-, JPEG- oder PNG-Datei hoch.",
    "wallet.institutional.removeFile": "Datei entfernen",
    "wallet.institutional.selectCustodian":
      "Bitte wählen Sie einen Verwahrer aus.",
    "wallet.institutional.selectCustodianOption": "Verwahrer auswählen...",
    "wallet.institutional.submit": "Zur Prüfung einreichen",
    "wallet.institutional.submittedDesc":
      "Ihre institutionelle Wallet-Registrierung wird geprüft. Sie erhalten innerhalb von 3 Werktagen eine E-Mail.",
    "wallet.institutional.submittedTitle": "Wallet zur Prüfung eingereicht",
    "wallet.institutional.submitting": "Wird eingereicht...",
    "wallet.institutional.subtitle":
      "Geben Sie die Details Ihres vom Verwahrer verwalteten Wallets an und laden Sie zur Verifizierung ein Bestätigungsdokument hoch.",
    "wallet.institutional.title":
      "Ein institutionelles Verwahrungs-Wallet registrieren",
    "wallet.institutional.uploadFile": "Bestätigungsdatei hochladen",
    "wallet.institutional.uploadRequired":
      "Bitte laden Sie ein Bestätigungsdokument hoch.",

    // Wallet - Safe
    "wallet.safe.address": "Safe-Adresse",
    "wallet.safe.chain": "Netzwerk",
    "wallet.safe.connectFirst":
      "Bitte verbinden Sie zuerst Ihr Unterzeichner-Wallet.",
    "wallet.safe.connectSigner": "Unterzeichner-Wallet verbinden",
    "wallet.safe.createNew": "Ein neues Safe erstellen",
    "wallet.safe.createNewDesc":
      "Öffnet app.safe.global, wo Sie ein neues Multisig erstellen können. Kommen Sie hierher zurück, sobald es bereitgestellt ist.",
    "wallet.safe.haveOne": "Ich habe bereits ein Safe",
    "wallet.safe.haveOneDesc":
      "Geben Sie Ihre Safe-Adresse ein und bestätigen Sie die Kontrolle, indem Sie eine Nachricht von einem Unterzeichner-Wallet signieren.",
    "wallet.safe.invalidAddress":
      "Bitte geben Sie eine gültige Ethereum-Adresse ein (0x...)",
    "wallet.safe.rejected": "Signaturanfrage wurde abgelehnt.",
    "wallet.safe.signError":
      "Verifizierungsnachricht konnte nicht signiert werden. Bitte versuchen Sie es erneut.",
    "wallet.safe.signVerify": "Signieren, um die Kontrolle zu bestätigen",
    "wallet.safe.signerWallet": "Unterzeichner-Wallet",
    "wallet.safe.subtitle":
      "Ein Safe erfordert mehrere Unterzeichner, um jede Transaktion zu genehmigen, und bietet so das höchste Sicherheitsniveau für die Gelder Ihrer Organisation.",
    "wallet.safe.title": "Ein Safe-Multisig-Wallet einrichten",
    "wallet.safe.verifyTitle": "Safe-Eigentum verifizieren",
    "wallet.safe.verifying": "Wird verifiziert...",

    // Wallet - Setup
    "wallet.setup.addAnother": "Weiteres hinzufügen",
    "wallet.setup.custodian": "Verwahrer",
    "wallet.setup.deleteFailed": "Wallet konnte nicht entfernt werden",
    "wallet.setup.eoaDesc":
      "Ein Standard-Wallet, das von einem privaten Schlüssel kontrolliert wird. Am einfachsten, aber am wenigsten sicher für den organisatorischen Einsatz.",
    "wallet.setup.eoaTitle": "Einzelner Unterzeichner (EOA)",
    "wallet.setup.institutionalDesc":
      "Verwaltet von einem qualifizierten Verwahrer (Fireblocks, Anchorage usw.). Erfordert ein Bestätigungsdokument.",
    "wallet.setup.institutionalTitle": "Institutionelle Verwahrung",
    "wallet.setup.makePrimary": "Als primär festlegen",
    "wallet.setup.primary": "Primär",
    "wallet.setup.primaryFailed":
      "Primäres Wallet konnte nicht aktualisiert werden",
    "wallet.setup.primaryUpdated": "Primäres Wallet aktualisiert",
    "wallet.setup.recommended": "Empfohlen",
    "wallet.setup.remove": "Wallet entfernen",
    "wallet.setup.safeDesc":
      "Mehrere Unterzeichner sind für jede Transaktion erforderlich. Höchste Sicherheit für Organisationsgelder.",
    "wallet.setup.safeSigners": "Unterzeichner",
    "wallet.setup.safeTitle": "Multisig Safe",
    "wallet.setup.subtitle":
      "Wählen Sie, wie Ihre Organisation Krypto-Spenden erhalten soll. Wir empfehlen ein Multisig-Wallet für maximale Sicherheit.",
    "wallet.setup.title": "Richten Sie Ihr Empfangs-Wallet ein",
    "wallet.setup.viewExplorer": "Im Block-Explorer anzeigen",
    "wallet.setup.walletAdded": "Wallet erfolgreich registriert",
    "wallet.setup.walletDeleted": "Wallet entfernt",
    "wallet.setup.walletsTitle": "Empfangs-Wallets",

    // Admin - Nav
    "admin.nav.dashboard": "Dashboard",
    "admin.nav.reports": "Berichte & Analysen",
    "admin.nav.charities": "Organisationen",
    "admin.nav.donations": "Spenden",
    "admin.nav.impactMetrics": "Wirkungskennzahlen",
    "admin.nav.portfolioFunds": "Portfolio-Fonds",
    "admin.nav.contentModeration": "Inhaltsmoderation",
    "admin.nav.settings": "Systemeinstellungen",
    "admin.nav.overview": "Übersicht",
    "admin.nav.operations": "Betrieb",
    "admin.nav.consoleLabel": "Admin-Konsole",

    // Admin - Shell
    "admin.shell.searchPlaceholder": "Spender, Organisationen, Tx-Hash suchen…",
    "admin.shell.searchLabel": "Die Admin-Konsole durchsuchen",
    "admin.shell.notifications": "Benachrichtigungen",
    "admin.shell.adminLabel": "Admin",
    "admin.shell.superAdmin": "Super-Admin",
    "admin.shell.signOut": "Abmelden",
    "admin.shell.backToPublicSite": "Zurück zur öffentlichen Website",
    "admin.shell.homeLink": "Give Protocol Startseite",

    // Admin - Dashboard (new keys)
    "admin.dashboard.severityHigh": "Hohe Priorität",
    "admin.dashboard.severityMedium": "Erfordert Aufmerksamkeit",
    "admin.dashboard.severityLow": "Zur Prüfung",
    "admin.dashboard.alertOldest": "Älteste eingereichte Anfrage",
    "admin.dashboard.alertReviewHint":
      "Prüfung, um den Onboarding-Prozess voranzutreiben",
    "admin.dashboard.reviewQueue": "Prüfwarteschlange",
    "admin.dashboard.kpiDonorsSub": "{{count}} neu in den letzten 30 Tagen",
    "admin.dashboard.kpiPending": "{{count}} ausstehend",
    "admin.dashboard.awaitingVerification": "Warten auf Verifizierung",
    "admin.dashboard.kpiVerifiedSub": "von {{total}} insgesamt genehmigt",
    "admin.dashboard.kpiVolunteersActive": "Aktive Anmeldungen",
    "admin.dashboard.kpiVolunteersSub": "Keine aktiven Anmeldungen",
    "admin.dashboard.donationVolume": "Spendenvolumen",
    "admin.dashboard.donationVolumeSub": "{{range}} · Krypto + Fiat kombiniert",
    "admin.dashboard.range30d": "Letzte 30 Tage",
    "admin.dashboard.range90d": "Letzte 90 Tage",
    "admin.dashboard.rangeYtd": "Seit Jahresbeginn",
    "admin.dashboard.volumeEmptyTitle": "Noch keine Spenden erfasst",
    "admin.dashboard.volumeEmptySub":
      "Das Volumen wird hier angezeigt, sobald die erste Spende abgeschlossen ist",
    "admin.dashboard.totalVolume": "Gesamtvolumen",
    "admin.dashboard.crypto": "Krypto",
    "admin.dashboard.fiat": "Fiat",
    "admin.dashboard.activitySubtitle": "Plattformereignisse in Echtzeit",
    "admin.dashboard.viewAllActivity": "Alle Aktivitäten anzeigen",
    "admin.dashboard.viewAllDonations": "Alle Spenden anzeigen",

    // Admin - Charity (new keys)
    "admin.charity.tabAll": "Alle",
    "admin.charity.review": "Prüfen",
    "admin.charity.colOrganization": "Organisation",
    "admin.charity.colRaised": "Gesammelt",
    "admin.charity.colSubmitted": "Eingereicht",
    "admin.charity.searchAria": "Organisationen suchen",
    "admin.charity.reviewTitle": "{{name}} prüfen",
    "admin.charity.submittedRelative": "Eingereicht {{when}}",
    "admin.charity.contactEmail": "E-Mail",
    "admin.charity.contactPhone": "Telefon",
    "admin.charity.raisedUnavailable": "Keine Gesamtspendensumme verfügbar",

    // Admin - Error
    "admin.error.title": "Fehler beim Laden der Daten",
    "admin.error.recentActivity": "Fehler beim Laden der letzten Aktivitäten",
    "admin.error.alerts": "Fehler beim Laden der Benachrichtigungen",
    "admin.error.donationVolume": "Fehler beim Laden des Spendenvolumens",

    // Donation - Gas
    "donation.gas.estimating": "Netzwerkgebühr wird geschätzt…",
    "donation.gas.label": "Geschätzte Netzwerkgebühr",
    "donation.gas.highGasWarning":
      "Hohe Gas-Warnung: Die geschätzte Gebühr beträgt {{usd}}, das sind {{pct}} Ihrer Spende.",
    "donation.gas.highGasSuggestion":
      "Erwägen Sie eine größere Spende oder den Wechsel zu einer Chain mit niedrigeren Gebühren.",
    "donation.gas.l2Hint":
      "Für niedrigere Gebühren versuchen Sie es mit {{chains}}.",
  },
};
